export const etkinlikler = [
  {
    "id": "10-kasim-ataturk-u-anma",
    "title": "10 KASIM ATATÜRK'Ü ANMA",
    "image": "/files/images/l1011201815505919.JPG",
    "description": "10 KASIM ATATÜRK'Ü ANMATürkiye Cumhuriyeti’nin kurucusu büyük önder ATATÜRK’ün ölümünün 79. Yılını 10 Kasım günü okulumuz konferans salonunda andık.ATATÜRK’ün yurt severliği, devrimleri, ilkeleri, fikirleri ışıkında bizler de Güney Gelişim Okulları olarak her 10 Kasım da olduğu gibi atamızı büyük özlem ve saygıyla andık.Öğrencilerimizin hazırlamış olduğu “Atatürk Oratoryosu” sergilendi. Okul koromuzun hazırlamış olduğu şarkılar seslendirildi. Öğrencilerimizin ve öğretmenlerimizin Atatürk ile ilgili söylediği sözler, okuduğu şiirler günün anlam ve önemini kurgularken atamıza bağlılığımızı bir kez daha göstermiş olduk. Oratoryo boyunca süren slayt gösterisi bir tarih şeridi gibi izleyenlere görsel bir şölen sunmuş oldu.Öğrencilerimizin hazırlamış olduğu resim sergisi “Atatürk Haftası” boyunca okulumuzda sergilendi. Atamıza bağlı kalarak görevimizi yerine getirmenin kıvancı içinde programımız sona erdi.",
    "gallery": [],
    "video": "https://www.youtube.com/embed/GhNEHeDWJQU?ecver=1"
  },
  {
    "id": "29-ekim-cumhuriyet-bayrami",
    "title": "29 EKİM CUMHURİYET BAYRAMI",
    "image": "/files/images/l31102018112435491.JPG",
    "description": "29 EKİM CUMHURİYET BAYRAMI29 Ekim, Cumhuriyetimizin 95.yıl dönümü kutlamaları kapsamında büyük hazırlıklar yapılarak ve emek sarf edilerek gerçekleştirdiğimiz törenimizi, velilerimizin de yüksek katılımıyla Cumhuriyet’e yakışır bir şekilde okulumuzun konferans salonunda büyük coşku ve heyecanla kutladık.Atatürk’ün bize emanet ettiği Cumhuriyet’e daima sahip çıkacağız ve onu ilelebet yaşatacağız.",
    "gallery": [
      "/files/images/l31102018112435491.JPG",
      "/files/images/l31102018112435850.JPG",
      "/files/images/l31102018112535179.JPG",
      "/files/images/l31102018112535554.JPG",
      "/files/images/l31102018112535897.JPG",
      "/files/images/l31102018112635257.JPG",
      "/files/images/l31102018112635633.JPG",
      "/files/images/l31102018112635960.JPG",
      "/files/images/l31102018112735350.JPG",
      "/files/images/l31102018112735741.JPG",
      "/files/images/l3110201811283585.JPG",
      "/files/images/l31102018112835397.JPG",
      "/files/images/l31102018112835710.JPG",
      "/files/images/l3110201811293538.JPG",
      "/files/images/l31102018112935366.JPG",
      "/files/images/l31102018112935679.JPG",
      "/files/images/l3110201811303538.JPG",
      "/files/images/l31102018113035366.JPG",
      "/files/images/l31102018113035663.JPG",
      "/files/images/l311020181131357.JPG",
      "/files/images/l31102018113135335.JPG",
      "/files/images/l31102018113135710.JPG",
      "/files/images/l3110201811323538.JPG"
    ],
    "video": ""
  },
  {
    "id": "okuyan-okul--gelisim-icin-oku",
    "title": "Okuyan Okul - Gelişim için Oku",
    "image": "/files/images/l1910201818454548.jpg",
    "description": "Okuyan Okul - Gelişim için OkuKitap Okuma Şenliği'nde ilkokul ve ortaokul öğrencilerimiz kitapların kendi dünyalarında nasıl bir anlam ifade ettiğini yaptıkları canlandırmalarla anlattılar.Öğrencilerimizle birlikte bir kitabın yaşamın içine,aklımıza nasıl girdiğini tamamen yaratıcılık ve hayal gücüyle bize neler anlatabildiğini gördük.",
    "gallery": [
      "/files/images/l1910201818454548.jpg",
      "/files/images/l1910201818454705.jpg",
      "/files/images/l1910201818454908.jpg",
      "/files/images/l191020181846480.jpg",
      "/files/images/l1910201818464220.jpg",
      "/files/images/l1910201818464392.jpg",
      "/files/images/l1910201818464548.jpg",
      "/files/images/l1910201818464705.jpg",
      "/files/images/l1910201818464861.jpg",
      "/files/images/l191020181847433.jpg",
      "/files/images/l1910201818474205.jpg",
      "/files/images/l1910201818474361.jpg",
      "/files/images/l1910201818474533.jpg",
      "/files/images/l1910201818474673.jpg",
      "/files/images/l19102018182231535.jpg",
      "/files/images/l19102018182331223.jpg",
      "/files/images/l19102018182331879.jpg",
      "/files/images/l19102018182431520.jpg",
      "/files/images/l19102018182531145.jpg",
      "/files/images/l19102018182531738.jpg",
      "/files/images/l19102018182631410.jpg",
      "/files/images/l191020181827314.jpg"
    ],
    "video": ""
  },
  {
    "id": "saglikli-beslenme",
    "title": "SAĞLIKLI BESLENME",
    "image": "/files/images/l18102018123457148.jpg",
    "description": "SAĞLIKLI BESLENMEİnsanın sağlıklı bir şekilde yaşayabilmesi için en önemli kurallardan biri de doğru beslenmesidir. Bu amaçla Sağlık Uzman Koçu Elif Ezgi Uzmansel’in \"Sağlıklı Yaşam Alışkanlıklarımız\" konulu sunumuyla anaokulu ve ilkokul öğrencilerimiz sağlıklı ve dengeli beslenmenin ne kadar önemli olduğunun farkına vararak bunu sordukları sorularla daha da anlamlı hale getirdiler.",
    "gallery": [
      "/files/images/l18102018123457148.jpg",
      "/files/images/l18102018123457351.jpg",
      "/files/images/l18102018123457538.jpg",
      "/files/images/l18102018123457741.jpg"
    ],
    "video": ""
  },
  {
    "id": "okul-baskan-ve-baskan-yardimcisi-secimleri",
    "title": "Okul Başkan ve Başkan Yardımcısı Seçimleri",
    "image": "/files/images/l11102018103524427.jpg",
    "description": "Okul Başkan ve Başkan Yardımcısı Seçimleri2018-2019 eğitim öğretim yılı okul başkan ve başkan yardımcısı seçimleri ilkokul ve ortaokul öğrencilerimizin katılımıyla bu yıl da tatlı bir rekabet ve başarılı bir propaganda süreci ile gerçekleştirildi. Seçme seçilme, özgürlük, saygı ve demokrasi kültürü temel alınarak gerçekleştiren seçimlerimizde; 7- B sınıfından Barış Saygı okul başkanı, 6-B sınıfından Ali Emre Yüzükçü okul başkan yardımcısı seçildi. Seçilen öğrencilerimizi tebrik ediyor verimli ve başarılı bir yıl geçirmelerini diliyoruz.",
    "gallery": [
      "/files/images/l11102018103524427.jpg",
      "/files/images/l11102018103524552.jpg",
      "/files/images/l11102018103524677.jpg",
      "/files/images/l11102018103524787.jpg",
      "/files/images/l11102018103524896.jpg",
      "/files/images/l1110201810362421.jpg",
      "/files/images/l11102018103624148.jpg",
      "/files/images/l11102018103624740.jpg",
      "/files/images/l11102018103724396.jpg",
      "/files/images/l11102018103724990.jpg",
      "/files/images/l11102018103824599.jpg",
      "/files/images/l11102018103924177.jpg",
      "/files/images/l11102018103924834.jpg",
      "/files/images/l11102018104024568.jpg",
      "/files/images/l11102018104124224.jpg",
      "/files/images/l11102018104124818.jpg"
    ],
    "video": ""
  },
  {
    "id": "dunya-hayvanlari-koruma-gunu",
    "title": "Dünya Hayvanları Koruma Günü",
    "image": "/files/images/l4102018135127773.jpg",
    "description": "Dünya Hayvanları Koruma GünüHayvanları Koruma Günü hepimiz için tek bir gün değil, hayatta bizlerle varlığını sürdüren tüm dostlarımızı korumak ve sevmek hepimizin görevidir. Dostlarımızı çok seviyoruz…",
    "gallery": [
      "/files/images/l4102018135127773.jpg",
      "/files/images/l410201813522723.jpg",
      "/files/images/l4102018135227180.jpg",
      "/files/images/l4102018135227789.jpg",
      "/files/images/l4102018135327398.jpg",
      "/files/images/l4102018135327976.jpg",
      "/files/images/l4102018135427555.jpg",
      "/files/images/l4102018135427695.jpg",
      "/files/images/l4102018135427851.jpg"
    ],
    "video": ""
  },
  {
    "id": "sporun-mutfagindakiler",
    "title": "Sporun Mutfağındakiler",
    "image": "/files/images/l279201810233943.JPG",
    "description": "Sporun MutfağındakilerMersin Büyükşehir Belediyesinin düzenlemiş olduğu “ Sporun Mutfağındakiler ” panelinde öğrencilerimizi milli voleybolcu Neslihan Demir Güler ile buluşturduk. Sporu yaşam tarzı edinen, voleybola ve yaşama dair tecrübelerini paylaşan Neslihan Demir Güler’e, öğrencilerimiz merak ettikleri soruları sorarken eğlenerek öğrenmenin heyecanını yaşadılar.",
    "gallery": [
      "/files/images/l279201810233943.JPG",
      "/files/images/l279201810243272.JPG",
      "/files/images/l279201810243584.JPG",
      "/files/images/l279201810243881.JPG",
      "/files/images/l279201810253193.JPG",
      "/files/images/l279201810253506.JPG"
    ],
    "video": ""
  },
  {
    "id": "yonlendirmesiz-oyun-egitimi",
    "title": "Yönlendirmesiz Oyun Eğitimi",
    "image": "/files/images/l1392018172850373.jpg",
    "description": "Yönlendirmesiz Oyun EğitimiÖğretmenlerimize yönelik seminer ve hizmet içi eğitim çalışmalarından belki de en eğlencelisi \"Yönlendirmesiz Oyun\" eğitimiydi.Anaokulumuzda hayata geçirmek üzere hazırlıklarına başladığımız, çocuklarımızın gelişimine büyük katkı sağlayacağına inandığımız eğitim, Uzman Psikolog Hülya ÜSTEKİDAĞ tarafından verilen 2 günlük yoğun bir seminer ve atölye çalışmasıyla tamamlandı.",
    "gallery": [
      "/files/images/l1392018172850373.jpg",
      "/files/images/l1392018172850716.jpg",
      "/files/images/l1392018172850982.jpg",
      "/files/images/l139201817295091.jpg",
      "/files/images/l1392018172950263.jpg"
    ],
    "video": ""
  },
  {
    "id": "sanat-haftasi-etkinlikleri",
    "title": "SANAT HAFTASI ETKİNLİKLERİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "SANAT HAFTASI ETKİNLİKLERİŞiir Dİnletisi(Resim ve Videolar)http://www.guneygelisim.k12.tr/siir-dinletisi/2/11591. ve 2. Sınıflarımızın Resitalleri(Resim ve Videolar)http://www.guneygelisim.k12.tr/1-ve-2-siniflarimizin-resitalleri/2/11573. ve 4.Sınıflarımızın Resitalleri(Resim ve Videolar)http://www.guneygelisim.k12.tr/sanat-haftasi-resitaller-3-ve-4-siniflarimiz/2/11635. 6. ve 7.Sınıflarımızın Resitalleri(Resim ve Videolar)http://www.guneygelisim.k12.tr/sanat-haftasi-resitaller-5-6-ve-7-siniflarimiz/2/1164\"Keşanlı Ali Destanı\" Tiyatro Kulübü(Resim ve Videolar)http://www.guneygelisim.k12.tr/sanat-haftasi-kesanli-ali-destani/2/1166Sanat Gecesi(Resim ve Videolar)http://www.guneygelisim.k12.tr/sanat-haftasi-sanat-gecesi/2/1167",
    "gallery": [],
    "video": ""
  },
  {
    "id": "teknoloji-bagimliligi-ve-teknolojinin-dogru-kullanilmasi",
    "title": "“Teknoloji Bağımlılığı ve Teknolojinin Doğru Kullanılması”",
    "image": "/files/images/l185201815203573.JPG",
    "description": "“Teknoloji Bağımlılığı ve Teknolojinin Doğru Kullanılması”2 Mayıs Çarşamba günü Prof. Dr. Kamuran Elbeyoğlu tarafından “ Teknoloji Bağımlılığı ve Teknolojinin Doğru Kullanılması ” konulu seminerimizi gerçekleştirdik.Katılan tüm velilerimize teşekkür ederiz.",
    "gallery": [
      "/files/images/l185201815203573.JPG",
      "/files/images/l1852018152135167.JPG",
      "/files/images/l1852018152235182.JPG"
    ],
    "video": ""
  },
  {
    "id": "1016-mayis-engelliler-haftasi",
    "title": "10-16 MAYIS ENGELLİLER HAFTASI",
    "image": "/files/images/l1552018104114268.JPG",
    "description": "10-16 MAYIS ENGELLİLER HAFTASIİlkokul ve ortaokul öğrencilerimizle “En Büyük Engel Sevgisizliktir” sloganıyla yola çıktığımız etkinliğimizde Gelişim Ailesi olarak yalnızca bir gün değil her gün engelli bireylere karşı bilinçli ve duyarlı olmanın değerini paylaşarak farkındalığımızı arttırdık.Okulumuzda hafta boyunca devam eden 10-16 Mayıs Engelliler Haftası kapsamında Özel Eğitim ve Rehabilitasyon Merkezinden gelen özel öğrencilerimizle birlikte masa tenisi, dans ve eğlenceli parkur etkinliklerini birlikte gerçekleştirdik.Farkındalık yaratan bu güzel gün için misafir öğrencilerimize teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l1552018104114268.JPG",
      "/files/images/l1552018104114627.JPG",
      "/files/images/l1552018104114955.JPG",
      "/files/images/l1552018104214830.JPG",
      "/files/images/l1552018104314924.JPG",
      "/files/images/l1552018104414268.JPG",
      "/files/images/l1652018185638852.jpg",
      "/files/images/l1652018185738508.jpg",
      "/files/images/l1652018185838102.jpg",
      "/files/images/l1652018185838742.jpg",
      "/files/images/l1652018185938336.jpg",
      "/files/images/l1652018185938977.jpg",
      "/files/images/l165201818039586.jpg",
      "/files/images/l165201818139149.jpg",
      "/files/images/l165201818139727.jpg"
    ],
    "video": "http://dizihitplayer.xyz/player/flex/fa79d795fbf89f4b08eea1d892110106"
  },
  {
    "id": "ortaokullu-olmak",
    "title": "“ORTAOKULLU OLMAK”",
    "image": "/files/images/l155201895952525.JPG",
    "description": "“ORTAOKULLU OLMAK”4. VE 5. SINIFLAR ARASINDA YAPILAN “ORTAOKULLU OLMAK” İÇERİKLİ SÖYLEŞİ VE ORYANTASYON ÇALIŞMASIİlkokul 4. Sınıftan ortaokula geçecek olan sevgili öğrencilerimize, bu sürece hazırlık yapabilmeleri ve ortaokulda yüksek uyum sağlayabilmeleri adına ortaokul ve ilkokul rehberlik birimleri tarafından düzenlenen söyleşi etkinliği gerçekleştirilmiştir. Söyleşide rehber öğretmenimizin sunumunun ardından 5. Sınıf öğrencilerimiz bu geçiş sürecinde kendilerinin de yaşamış oldukları kaygı, heyecan ve ortaokula dair merak ettikleri durumlarla ilgili bir yıllık deneyimlerini arkadaşlarıyla paylaşmışlardır.Öğrencilerimize çok teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l155201895952525.JPG",
      "/files/images/l155201895952665.JPG",
      "/files/images/l155201895952790.JPG",
      "/files/images/l155201895952900.JPG",
      "/files/images/l15520189053243.JPG",
      "/files/images/l15520189053571.JPG",
      "/files/images/l15520189053900.JPG"
    ],
    "video": ""
  },
  {
    "id": "719-yas-aile-egitimi-ortaokulilkokul-2-grup",
    "title": "7-19 YAŞ AİLE EĞİTİMİ ORTAOKUL-İLKOKUL 2. GRUP",
    "image": "/files/images/l1452018151353877.jpg",
    "description": "7-19 YAŞ AİLE EĞİTİMİ ORTAOKUL-İLKOKUL 2. GRUPSevgili anneler ve babalar,İlkokul ve ortaokul rehberlik birimi tarafından planlanan ‘’7-19 Yaş Aile Eğitimimizin ‘’ 2. Grup çalışmalarını da sizlerin yoğun ve etkin katılımıyla tamamlamış olmanın onurunu ve mutluluğunu yaşamaktayız. Siz değerli velilerimizin hayatlarına dokunabilmek bizler için hem çok kıymetli hem de çok keyifliydi.Başka eğitimlerde görüşmek dileğiyle...",
    "gallery": [
      "/files/images/l1452018151353877.jpg",
      "/files/images/l1452018151353970.jpg",
      "/files/images/l145201815145333.jpg",
      "/files/images/l1452018151453111.jpg",
      "/files/images/l1452018151453189.jpg",
      "/files/images/l1452018151453267.jpg",
      "/files/images/l1452018151453361.jpg",
      "/files/images/l1452018151453470.jpg",
      "/files/images/l1452018151453548.jpg",
      "/files/images/l1452018151453627.jpg",
      "/files/images/l1452018151453752.jpg",
      "/files/images/l1452018151453861.jpg",
      "/files/images/l1452018151453955.jpg",
      "/files/images/l145201815155333.jpg",
      "/files/images/l145201815155395.jpg",
      "/files/images/l1452018151553173.jpg",
      "/files/images/l1452018151553252.jpg",
      "/files/images/l1452018151553345.jpg",
      "/files/images/l1452018151553423.jpg",
      "/files/images/l1452018151553517.jpg",
      "/files/images/l1452018151553595.jpg",
      "/files/images/l1452018151553658.jpg",
      "/files/images/l1452018151553736.jpg",
      "/files/images/l1452018151553830.jpg",
      "/files/images/l1452018151553892.jpg",
      "/files/images/l14520181516532.jpg",
      "/files/images/l145201815165395.jpg",
      "/files/images/l1452018151653205.jpg",
      "/files/images/l1452018151653283.jpg",
      "/files/images/l1452018151653377.jpg",
      "/files/images/l1452018151653439.jpg",
      "/files/images/l1452018151653517.jpg",
      "/files/images/l1452018151653642.jpg",
      "/files/images/l1452018151653736.jpg",
      "/files/images/l1452018151653861.jpg",
      "/files/images/l1452018151653970.jpg",
      "/files/images/l145201815175348.jpg",
      "/files/images/l1452018151753173.jpg",
      "/files/images/l1452018151753267.jpg"
    ],
    "video": ""
  },
  {
    "id": "17-mersin-uluslararasi-muzik-festivali",
    "title": "17. Mersin Uluslararası Müzik Festivali",
    "image": "/files/images/l152018153952585.png",
    "description": "17. Mersin Uluslararası Müzik Festivali",
    "gallery": [
      "/files/images/l152018153952585.png"
    ],
    "video": "http://dizihitplayer.xyz/player/flex/7033bbe93c6b24a46918a21f8ad9a72a"
  },
  {
    "id": "719-yas-aile-egitimi-1-etap-sertifika-torenimiz",
    "title": "7-19 YAŞ AİLE EĞİTİMİ 1. ETAP SERTİFİKA TÖRENİMİZ",
    "image": "/files/images/l94201814200384.jpg",
    "description": "7-19 YAŞ AİLE EĞİTİMİ 1. ETAP SERTİFİKA TÖRENİMİZSiz değerli velilerimizle 4 hafta boyunca büyük bir ilgiyle, yoğun katılım ve paylaşımlarımızla yürüttüğümüz 7-19 Yaş Aile Eğitimimizin sizlere ve okulumuza kattığı değerden dolayı çok mutluyuz. Her zaman belirttiğimiz gibi sizler çocuklarınızın en iyi ebeveynlerisiniz. Bu değeri taşımak ve korumak adına vermiş olduğunuz çabanızdan dolayı sizleri kutluyoruz.",
    "gallery": [
      "/files/images/l94201814200384.jpg",
      "/files/images/l94201814200446.jpg",
      "/files/images/l94201814200712.jpg",
      "/files/images/l94201814200837.jpg",
      "/files/images/l94201814210102.jpg",
      "/files/images/l94201814210196.jpg"
    ],
    "video": ""
  },
  {
    "id": "18-mart-canakkale-zaferi",
    "title": "18 MART ÇANAKKALE ZAFERİ",
    "image": "/files/images/l183201823232056.JPG",
    "description": "18 MART ÇANAKKALE ZAFERİ103. Yılında başta GAZİ MUSTAFA KEMAL ATATÜRK olmak üzere, aziz şehitlerimizi saygı ve minnetle anıyoruz.16 Mart Cuma günü, yabancı güçler karşısında vatan uğruna şehit verdiğimiz kahraman askerlerimizin tarihe altın harflerle yazdığı \"ÇANAKKALE GEÇİLMEZ\" destanını okulumuzda bir kez daha yaşattık. 103. yıldönümünde Çanakkale Zaferi'ni ve aziz şehitlerimizi minnetle andık.",
    "gallery": [
      "/files/images/l183201823232056.JPG",
      "/files/images/l1832018232420119.JPG",
      "/files/images/l1832018232520228.JPG",
      "/files/images/l1832018232620338.JPG",
      "/files/images/l1832018232720447.JPG",
      "/files/images/l1832018232820697.JPG",
      "/files/images/l1832018232920791.JPG",
      "/files/images/l1832018233020931.JPG",
      "/files/images/l18320182332209.JPG"
    ],
    "video": "https://www.youtube.com/embed/kz52y7Dc624?ecver=1"
  },
  {
    "id": "golf-gunleri",
    "title": "GOLF GÜNLERİ",
    "image": "/files/images/l1532018173126522.jpg",
    "description": "GOLF GÜNLERİGelişim öğrencileri sporun her dalını deneyimliyor. 12 Mart Pazartesi günü ortaokul öğrencilerimiz arasında başlayan  “ Golf Turnuvası ” devam ediyor. Çocuklarımızın fiziksel gelişimini destekleyen, karar verme , sorumluluk  duygusunu geliştiren, zeka gelişimine katkı sağlayan  golf derslerinde keyifli vakit geçiriyorlar...",
    "gallery": [
      "/files/images/l1532018173126522.jpg",
      "/files/images/l1532018173126651.jpg",
      "/files/images/l1532018173126788.jpg",
      "/files/images/l1532018173126897.jpg",
      "/files/images/l15320181732267.jpg",
      "/files/images/l1532018173226147.jpg",
      "/files/images/l1532018173226257.jpg",
      "/files/images/l1532018173226366.jpg",
      "/files/images/l1532018173226429.jpg",
      "/files/images/l1532018173226475.jpg"
    ],
    "video": ""
  },
  {
    "id": "8-mart-dunya-kadinlar-gunu",
    "title": "8 Mart Dünya Kadınlar Günü",
    "image": "/files/images/l83201814413395.jpg",
    "description": "8 Mart Dünya Kadınlar Günü",
    "gallery": [
      "/files/images/l83201814413395.jpg"
    ],
    "video": ""
  },
  {
    "id": "yangin-tatbikati",
    "title": "YANGIN TATBİKATI",
    "image": "/files/images/l832018111256550.jpg",
    "description": "YANGIN TATBİKATIMersin Büyükşehir Belediyesi İtfaiye Daire Başkanlığı ekiplerince 19 Şubat Pazartesi günü “ Yangın Tatbikatı ” yapılmıştır. Tüm öğrenci ve öğretmenlerimize temel yangın eğitimi hakkında bilgi verilmiş olup teorik ve pratik yangın eğitimi verilmiştir.",
    "gallery": [
      "/files/images/l832018111256550.jpg",
      "/files/images/l832018111356847.jpg",
      "/files/images/l832018111456425.jpg",
      "/files/images/l83201811155650.jpg",
      "/files/images/l832018111556659.jpg",
      "/files/images/l832018111556768.jpg"
    ],
    "video": "https://www.youtube.com/embed/hRzIOoXdwHE?ecver=1"
  },
  {
    "id": "8-mart-dunya-kadinlar-gunu-resim-sergimiz",
    "title": "8 Mart Dünya Kadınlar Günü Resim Sergimiz",
    "image": "/files/images/l832018114244100.jpg",
    "description": "8 Mart Dünya Kadınlar Günü Resim SergimizLise, ortaokul öğrencilerimiz tarafından hazırlanan ve büyük ilgi gören “ 8 Mart Dünya Kadınlar Günü ” resim sergimizi tüm öğretmen ve öğrencilerimizle gezerek bugünü daha da anlamlı kıldık.",
    "gallery": [
      "/files/images/l832018114244100.jpg",
      "/files/images/l832018114244163.jpg",
      "/files/images/l832018114244225.jpg",
      "/files/images/l832018114244272.jpg",
      "/files/images/l832018114244350.jpg",
      "/files/images/l832018114244491.jpg",
      "/files/images/l832018114244607.jpg",
      "/files/images/l832018114244741.jpg",
      "/files/images/l832018114244850.jpg",
      "/files/images/l832018114244975.jpg",
      "/files/images/l832018114344104.jpg",
      "/files/images/l832018114344241.jpg",
      "/files/images/l93201893631215.jpg",
      "/files/images/l93201893631262.jpg"
    ],
    "video": ""
  },
  {
    "id": "egitim-teknolojileri-zirvesi",
    "title": "EĞİTİM TEKNOLOJİLERİ ZİRVESİ",
    "image": "/files/images/l73201815156697.jpg",
    "description": "EĞİTİM TEKNOLOJİLERİ ZİRVESİYeni eğitim yaklaşımları ve teknolojik yeniliklerden haberdar olup okulumuzu sürekli güncel tutmak adına geçtiğimiz hafta sonu İstanbul'da katıldığımız EĞİTİM TEKNOLOJİLERİ ZİRVESİ... Eğitim, iş ve teknoloji dünyasında alanında uzman yerli ve yabancı konuşmacıların katıldığı zirvede, hızla gelişen teknolojiyle beraber eğitimin ve mesleklerin gelecekte ne olacağı ile ilgili önemli bilgiler edindik.",
    "gallery": [
      "/files/images/l73201815156697.jpg"
    ],
    "video": ""
  },
  {
    "id": "okulumuz-toplum-hizmeti-calismalarinda",
    "title": "Okulumuz Toplum Hizmeti Çalışmalarında...",
    "image": "/files/images/l2222018145121580.jpg",
    "description": "Okulumuz Toplum Hizmeti Çalışmalarında...Okul Aile Birliği ve rehber öğretmenlerimizin organize ettiği, ilkokul-ortaokul öğrenci ve velilerimizin desteği ile toplanan kıyafet, oyuncak ve kırtasiye malzemeleri Darıpınarı Şehit Oğuzhan Sezer Yatılı Bölge Ortaokulundaki ihtiyacı olan öğrencilere ulaştırılmıştır. Destekleriniz için teşekkür ederiz.",
    "gallery": [
      "/files/images/l2222018145121580.jpg",
      "/files/images/l2222018145121674.jpg",
      "/files/images/l2222018145121768.jpg",
      "/files/images/l2222018145121862.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-sergisi",
    "title": "RESİM SERGİSİ",
    "image": "/files/images/l2822018112919860.png",
    "description": "RESİM SERGİSİ23 Nisan Ulusal Egemenlik ve Çocuk Bayramıetkinlikleri içerisinde tüm okul öğrencilerimizin katıldığı resim sergimiz zemin katımızda açıldı. Büyük bir görsel şölen yaratan tüm okul öğrencilerimizi kutluyoruz.",
    "gallery": [
      "/files/images/t_1.j_4171869159.jpg",
      "/files/images/t_2.j_1642114520.jpg",
      "/files/images/t_3.j_2954675555.jpg",
      "/files/images/t_4.j_2104761005.jpg",
      "/files/images/t_5.j_2317010761.jpg",
      "/files/images/t_6.j_8302575946.jpg",
      "/files/images/t_7.j_9634210467.jpg",
      "/files/images/t_8.j_6572687030.jpg",
      "/files/images/t_9.j_6774713397.jpg",
      "/files/images/t_10._7586023211.jpg",
      "/files/images/t_11._2513696552.jpg",
      "/files/images/t_12._8025323748.jpg",
      "/files/images/t_13._2155572772.jpg",
      "/files/images/t_14._9649927020.jpg",
      "/files/images/t_15._2792779803.jpg",
      "/files/images/t_16._1310998798.jpg",
      "/files/images/t_17._4017297626.jpg",
      "/files/images/t_19._4497186542.jpg",
      "/files/images/t_20._2765161395.jpg",
      "/files/images/t_20._2845270038.jpg",
      "/files/images/t_20._7313348651.jpg",
      "/files/images/t_21._3303186298.jpg",
      "/files/images/t_22._3302575946.jpg",
      "/files/images/t_26._5347558856.jpg",
      "/files/images/t_27._9201928973.jpg",
      "/files/images/t_30._7700464129.jpg",
      "/files/images/t_32._3346063495.jpg",
      "/files/images/t_33._5064050555.jpg",
      "/files/images/t_35._7802240252.jpg",
      "/files/images/t_37._34448505.jpg",
      "/files/images/t_74._6961633563.jpg",
      "/files/images/t_77._7025110125.jpg",
      "/files/images/t_87._7442132830.jpg",
      "/files/images/t_DSC_9727136492.jpg",
      "/files/images/t_36._4714929462.jpg",
      "/files/images/t_66._879169.jpg"
    ],
    "video": ""
  },
  {
    "id": "lise-kulup-tanitim-sayfamiz",
    "title": "LİSE KULÜP TANITIM SAYFAMIZ",
    "image": "/files/images/l1512201792720473.png",
    "description": "LİSE KULÜP TANITIM SAYFAMIZLise Kulüp Tanıtım Sayfamız için Tıklayınız...",
    "gallery": [
      "/files/images/l1512201792720473.png"
    ],
    "video": ""
  },
  {
    "id": "ogretmenler-gunu",
    "title": "ÖĞRETMENLER GÜNÜ",
    "image": "/files/images/l2411201792536952.png",
    "description": "ÖĞRETMENLER GÜNÜ",
    "gallery": [
      "/files/images/l2411201792536952.png"
    ],
    "video": ""
  },
  {
    "id": "2-uluslararasi-akdeniz-kentleri-sanat-bulusmasi",
    "title": "2. Uluslararası Akdeniz Kentleri Sanat Buluşması",
    "image": "/files/images/l16112017141138991.JPG",
    "description": "2. Uluslararası Akdeniz Kentleri Sanat Buluşması2. Uluslararası Akdeniz Kentleri Sanat Buluşması kapsamında 14 Kasım 2017 tarihinde Güney Gelişim Okulları konferans salonunda\"Azaltmak, Yeniden Kullanmak, Geri Dönüştürmek\" adlı söyleşi ve kısa film gösterimi konuşmacı Adroulla SHATİ ve çevirmen, şair F. Saadet BİLİR'in öğrencilerimizle bir araya gelmesiyle çok güzel verimli bir şekilde gerçekleştirildi.",
    "gallery": [
      "/files/images/l16112017141138991.JPG",
      "/files/images/l1611201714133853.JPG",
      "/files/images/l1611201714143853.JPG",
      "/files/images/l1611201714153853.JPG"
    ],
    "video": ""
  },
  {
    "id": "10-kasim-ataturk-u-anma",
    "title": "10 KASIM ATATÜRK'Ü ANMA",
    "image": "/images2/img2_files/logo.jpg",
    "description": "10 KASIM ATATÜRK'Ü ANMATürkiye Cumhuriyeti’nin kurucusu büyük önder ATATÜRK’ün ölümünün 79. Yılını 10 Kasım günü okulumuz konferans salonunda andık.ATATÜRK’ün yurt severliği, devrimleri, ilkeleri, fikirleri ışıkında bizler de Güney Gelişim Okulları olarak her 10 Kasım da olduğu gibi atamızı büyük özlem ve saygıyla andık.Öğrencilerimizin hazırlamış olduğu “Atatürk Oratoryosu” sergilendi. Okul koromuzun hazırlamış olduğu şarkılar seslendirildi. Öğrencilerimizin ve öğretmenlerimizin Atatürk ile ilgili söylediği sözler, okuduğu şiirler günün anlam ve önemini kurgularken atamıza bağlılığımızı bir kez daha göstermiş olduk. Oratoryo boyunca süren slayt gösterisi bir tarih şeridi gibi izleyenlere görsel bir şölen sunmuş oldu.Öğrencilerimizin hazırlamış olduğu resim sergisi “Atatürk Haftası” boyunca okulumuzda sergilendi. Atamıza bağlı kalarak görevimizi yerine getirmenin kıvancı içinde programımız sona erdi.",
    "gallery": [],
    "video": "https://www.youtube.com/embed/GhNEHeDWJQU?ecver=1"
  },
  {
    "id": "pearson-jetset-exams",
    "title": "Pearson JetSet Exams",
    "image": "/files/images/l14112017122234735.JPG",
    "description": "Pearson JetSet ExamsCongratulations were due to all our students who sat the Pearson JetSet Exams back in May.We were able to proudly present their results to them and celebrate their success.We look forward to celebrating their futuresuccesses as well.Geçtiğimiz yıl Mayıs ayında, Pearson JetSet Sınavları'na katılan tüm öğrencilerimizi aldıkları yüksek puanlardan dolayı tebrik ederiz.Onlara, sınav sonuçlarını gururla takdim edip, başarılarını kutladık.",
    "gallery": [
      "/files/images/l14112017122234735.JPG",
      "/files/images/l14112017122334829.JPG",
      "/files/images/l14112017122434813.JPG",
      "/files/images/l14112017122534516.JPG",
      "/files/images/l14112017122634316.JPG"
    ],
    "video": ""
  },
  {
    "id": "10-kasim-ataturk-u-anma",
    "title": "10 KASIM ATATÜRK'Ü ANMA",
    "image": "/files/images/l7112017224457164.jpg",
    "description": "10 KASIM ATATÜRK'Ü ANMATürkiye Cumhuriyeti’nin kurucusu büyük önder ATATÜRK’ün ölümünün 79. Yılını 10 Kasım günü okulumuz konferans salonunda andık.ATATÜRK’ün yurt severliği, devrimleri, ilkeleri, fikirleri ışıkında bizler de Güney Gelişim Okulları olarak her 10 Kasım da olduğu gibi atamızı büyük özlem ve saygıyla andık.Öğrencilerimizin hazırlamış olduğu “Atatürk Oratoryosu” sergilendi. Okul koromuzun hazırlamış olduğu şarkılar seslendirildi. Öğrencilerimizin ve öğretmenlerimizin Atatürk ile ilgili söylediği sözler, okuduğu şiirler günün anlam ve önemini kurgularken atamıza bağlılığımızı bir kez daha göstermiş olduk. Oratoryo boyunca süren slayt gösterisi bir tarih şeridi gibi izleyenlere görsel bir şölen sunmuş oldu.Öğrencilerimizin hazırlamış olduğu resim sergisi “Atatürk Haftası” boyunca okulumuzda sergilendi. Atamıza bağlı kalarak görevimizi yerine getirmenin kıvancı içinde programımız sona erdi.",
    "gallery": [],
    "video": "https://www.youtube.com/embed/GhNEHeDWJQU?ecver=1"
  },
  {
    "id": "29-ekim-cumhuriyet-bayrami",
    "title": "29 EKİM CUMHURİYET BAYRAMI",
    "image": "/files/images/l3010201715434431.JPG",
    "description": "29 EKİM CUMHURİYET BAYRAMI29 Ekim, Cumhuriyetimizin 95.yıl dönümü kutlamaları kapsamında büyük hazırlıklar yapılarak ve emek sarf edilerek gerçekleştirdiğimiz törenimizi, velilerimizin de yüksek katılımıyla Cumhuriyet’e yakışır bir şekilde okulumuzun konferans salonunda büyük coşku ve heyecanla kutladık.Atatürk’ün bize emanet ettiği Cumhuriyet’e daima sahip çıkacağız ve onu ilelebet yaşatacağız.",
    "gallery": [
      "/files/images/l31102018112435491.JPG",
      "/files/images/l31102018112435850.JPG",
      "/files/images/l31102018112535179.JPG",
      "/files/images/l31102018112535554.JPG",
      "/files/images/l31102018112535897.JPG",
      "/files/images/l31102018112635257.JPG",
      "/files/images/l31102018112635633.JPG",
      "/files/images/l31102018112635960.JPG",
      "/files/images/l31102018112735350.JPG",
      "/files/images/l31102018112735741.JPG",
      "/files/images/l3110201811283585.JPG",
      "/files/images/l31102018112835397.JPG",
      "/files/images/l31102018112835710.JPG",
      "/files/images/l3110201811293538.JPG",
      "/files/images/l31102018112935366.JPG",
      "/files/images/l31102018112935679.JPG",
      "/files/images/l3110201811303538.JPG",
      "/files/images/l31102018113035366.JPG",
      "/files/images/l31102018113035663.JPG",
      "/files/images/l311020181131357.JPG",
      "/files/images/l31102018113135335.JPG",
      "/files/images/l31102018113135710.JPG",
      "/files/images/l3110201811323538.JPG"
    ],
    "video": ""
  },
  {
    "id": "ilkokul-kulup-tanitim-sayfamiz",
    "title": "İLKOKUL KULÜP TANITIM SAYFAMIZ",
    "image": "/files/images/l25102017123516406.png",
    "description": "İLKOKUL KULÜP TANITIM SAYFAMIZİlkokul Kulup Tanıtım Sayfamız için tıklayınız.",
    "gallery": [
      "/files/images/l25102017123516406.png"
    ],
    "video": ""
  },
  {
    "id": "hadi-hep-birlikte-yapalim-lets-do-it-together-lass-uns-was-zusammen-machen",
    "title": "“Hadi Hep Birlikte Yapalım”  “Let’s Do It Together”  “Lass Uns Was Zusammen Machen”",
    "image": "/files/images/l1710201792745859.JPG",
    "description": "“Hadi Hep Birlikte Yapalım”  “Let’s Do It Together”  “Lass Uns Was Zusammen Machen”Okulumuzda 14 Ekim Cumartesi günü 09.30-12.00 saatleri arasında 4. ve 5. Sınıf öğrenci ve velilerimize yönelik“Hadi Hep Birlikte Yapalım ”etkinliğini düzenlendik.Spor, Sanat, Satranç, Akıl Oyunları, Yabancı Dil, Kodlama, Drama branşlarından oluşan etkinliğimizeçocuklarımızla birlikte katılantüm velilerimize teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l1710201792745859.JPG",
      "/files/images/l1710201792845875.JPG",
      "/files/images/l1710201792945937.JPG",
      "/files/images/l1710201793045937.JPG",
      "/files/images/l1710201793145953.JPG",
      "/files/images/l1710201793245875.JPG",
      "/files/images/l1710201793345922.JPG",
      "/files/images/l1710201793445898.JPG",
      "/files/images/l1710201793545906.JPG",
      "/files/images/l1710201793645984.JPG",
      "/files/images/l171020179384578.JPG",
      "/files/images/l1710201793945140.JPG",
      "/files/images/l1710201794045109.JPG",
      "/files/images/l1710201794145125.JPG",
      "/files/images/l1710201794245109.JPG",
      "/files/images/l1710201794345218.JPG",
      "/files/images/l1710201794445234.JPG",
      "/files/images/l1710201794545296.JPG",
      "/files/images/l1710201794645281.JPG",
      "/files/images/l1710201794745281.JPG",
      "/files/images/l1710201794845328.JPG",
      "/files/images/l1710201794945343.JPG",
      "/files/images/l1710201795045390.JPG",
      "/files/images/l1710201795145437.JPG",
      "/files/images/l1710201795245546.JPG",
      "/files/images/l1710201795345515.JPG",
      "/files/images/l1710201795445671.JPG",
      "/files/images/l1710201795545812.JPG",
      "/files/images/l1710201795645937.JPG",
      "/files/images/l1710201795745890.JPG",
      "/files/images/l17102017959450.JPG",
      "/files/images/l17102017904646.JPG",
      "/files/images/l171020179146109.JPG"
    ],
    "video": "https://www.youtube.com/embed/fX6jNaMOttA?ecver=1"
  },
  {
    "id": "tenis-turnuvasi",
    "title": "TENİS TURNUVASI",
    "image": "/files/images/l11102017102417108.JPG",
    "description": "TENİS TURNUVASITürkiye Tenis Federasyonu’nun Mersin Tenis-Yelken ve Yüzme KulübündeDüzenlemiş Olduğu 8-9-10 Yaş Hafta SonuTenis TurnuvasındaÖdül Alan Öğrencilerimizi Kutlar, Başarılarının Devamını Dileriz.",
    "gallery": [
      "/files/images/l11102017102417108.JPG",
      "/files/images/l11102017102517154.jpg"
    ],
    "video": ""
  },
  {
    "id": "20172018-egitim-ogretim-yili-antrenman-programi",
    "title": "2017-2018 EĞİTİM ÖĞRETİM YILI ANTRENMAN PROGRAMI",
    "image": "/files/images/l2292017112935256.jpg",
    "description": "2017-2018 EĞİTİM ÖĞRETİM YILI ANTRENMAN PROGRAMI",
    "gallery": [
      "/files/images/l2292017112935256.jpg"
    ],
    "video": ""
  },
  {
    "id": "30-agustos-zafer-bayrami",
    "title": "30 AĞUSTOS ZAFER BAYRAMI",
    "image": "/files/images/l308201716260799.jpg",
    "description": "30 AĞUSTOS ZAFER BAYRAMI",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/b308201716390846.jpg",
      "/files/images/l308201716260799.jpg"
    ],
    "video": ""
  },
  {
    "id": "20172018--egitim-ogretim-donemi-sinif-kayitlarimiz-dolmustur-duydugunuz-guven-ve-ilgiden-dolayi-cok-tesekkur-ederiz",
    "title": "2017-2018  Eğitim- Öğretim dönemi sınıf kayıtlarımız dolmuştur. Duyduğunuz güven ve ilgiden dolayı çok teşekkür ederiz.",
    "image": "/images2/img2_files/logo.jpg",
    "description": "2017-2018  Eğitim- Öğretim dönemi sınıf kayıtlarımız dolmuştur. Duyduğunuz güven ve ilgiden dolayı çok teşekkür ederiz.2017-2018  Eğitim- Öğretim dönemi sınıf kayıtlarımız dolmuştur. Duyduğunuz güven ve ilgiden dolayı çok teşekkür ederiz.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "barkan-canbolat-katildigi-romanya-sinaia-uluslararasi-gitar-festivalinde-3-olmustur",
    "title": "Barkan CANBOLAT katıldığı Romanya Sinaia Uluslararası Gitar Festivalinde 3. olmuştur",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Barkan CANBOLAT katıldığı Romanya Sinaia Uluslararası Gitar Festivalinde 3. olmuşturOkulumuz öğrencilerinden Barkan CANBOLAT katıldığı Romanya Sinaia Uluslararası Gitar Festivali'nde 3. olmuştur .Öğrencimizin başarılarına başarı katması bizi gururlandırıyor .Yeteneğin ve azminle nice başarılara imza attığın güzel günler seninle olsun ...",
    "gallery": [],
    "video": ""
  },
  {
    "id": "close-count-yearend-finale",
    "title": "CLOSE COUNT YEAR-END FINALE",
    "image": "/images2/img2_files/logo.jpg",
    "description": "CLOSE COUNT YEAR-END FINALEOur Close Count Game was brought to a close for this school year with the presentation of certificates for the most frequent winners of the second term.  We applaud Maya Asena Karakaya, Yağmur Ada Civcik, Elis Budur, Doğa Gökgün, Naz Kurtuluş and Aleyna Eroğlu for their great guessing.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "yaz-antrenmanlarimiz",
    "title": "YAZ ANTRENMANLARIMIZ ",
    "image": "/files/images/l862017112619830.jpg",
    "description": "YAZ ANTRENMANLARIMIZYAZ ANTRENMANLARIMIZ",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c86201711017690.jpg.jpg",
      "/files/images/l862017112619830.jpg"
    ],
    "video": ""
  },
  {
    "id": "geleneksel-bahar-senligimiz",
    "title": "GELENEKSEL BAHAR ŞENLİĞİMİZ",
    "image": "/files/images/l1652017231513664.jpg",
    "description": "GELENEKSEL BAHAR ŞENLİĞİMİZ",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/c1652017231514836.jpg.jpg",
      "/files/images/l1652017231513664.jpg"
    ],
    "video": ""
  },
  {
    "id": "muzik-gecemize-hepiniz-davetlisiniz",
    "title": " Müzik Gecemize hepiniz davetlisiniz...",
    "image": "/files/images/l165201775843960.jpg",
    "description": "Müzik Gecemize hepiniz davetlisiniz...Müzik Gecemize hepiniz davetlisiniz...",
    "gallery": [
      "/files/images/l165201775843960.jpg"
    ],
    "video": ""
  },
  {
    "id": "make-your-best-move-chess-tournament",
    "title": "Make Your Best Move Chess Tournament",
    "image": "/files/images/l105201781654734.jpg",
    "description": "Make Your Best Move Chess TournamentOkulumuzda 4.sünü düzenlediğimiz \"Make Your Best Move\" Satranç Turnuvası İlkokulumuzdan 105, Ortaokulumuzdan 55 öğrencimizin katılımı ile gerçekleşti.Amacımız, satranç sporunun yarışma boyutlarını öğrencilerimize öğretmek, kazanmayı ve kaybetmeyi olgunlukla karşılamak, sonuçlardan bir deneyim dersi çıkarmak ve ilgilerini daha yüksek düzeye çıkarmaktır.Heyecan finale doğru yaklaştıkça doruk noktasına yükselirken, son saniyelerin seyir zevki, maç bitiminde alkışlanan bir mücadeleler, takdir, tebrik vardı.Bu yılın kazananları:1. Sınıf Erkekler Birincisi   Alp Arslanköylü1. Sınıf Kızlar Birincisi       Eliz Ovacıllı2. Sınıf Erkekler Birincisi    Burak Yağız Orhan2. Sınıf Kızlar Birincisi       Ceren Bozdoğan3. Sınıf Erkekler Birincisi    Onur Efe Aydemir3. Sınıf Kızlar  Birincisi       Alya Adıgüzel4. Sınıf Erkekler Birincisi    Aydın Altar Güvenoğlu4. Sınıf Kızlar Birincisi        Hatice Naz SolakOrta Okul Erkekler Birincisi   Ekin Can EsenOrta Okul Erkekler İkincisi    Ozan Barış AydemirOrta Okul Erkekler Üçüncüsü Utku Yiğit YazıcıOrta Okul Kızlar Birincisi     Emine Ada TekinOrta Okul Kızlar İkincisi      Doğa GökgünOrta Okul Kızlar Üçüncüsü  Elis Budurİlkokul Takımlar Birincisi  4A olurken, Orta Okul Takımlar Birincisi 5C oldu.Katılan bütün öğrencilerimizi gönülden kutluyoruz.",
    "gallery": [
      "/files/images/l105201781654734.jpg",
      "/files/images/l105201781654968.jpg",
      "/files/images/l105201781754172.jpg",
      "/files/images/l105201781754328.jpg",
      "/files/images/l105201781754469.jpg",
      "/files/images/l105201781754610.jpg",
      "/files/images/l105201781754734.jpg",
      "/files/images/l105201781754843.jpg",
      "/files/images/l10520178185416.jpg",
      "/files/images/l105201781854156.jpg",
      "/files/images/l105201781854265.jpg",
      "/files/images/l105201781854375.jpg",
      "/files/images/l105201781854468.jpg",
      "/files/images/l105201781854562.jpg",
      "/files/images/l105201781854687.jpg"
    ],
    "video": ""
  },
  {
    "id": "23-nisan-turnuvalari-haber",
    "title": "23 Nisan Turnuvaları Haber",
    "image": "/files/images/l1152017948441.JPG",
    "description": "23 Nisan Turnuvaları Haberİlimizde düzenlenen \"23 Nisan Çocuk Bayramı\" satranç turnuvasında 8 yaş genel kategorisinde Yücel Mert Öztürk 3.lük plaketi kazanırken, İlhan Berk Angı, Uğur Batu Kara, Burak Yağız Orhan, Muhsin Uğurel, Berk İsmi ise madalya kazandılar.Öğrencilerimizi kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l1152017948441.JPG",
      "/files/images/l11520179484885.JPG",
      "/files/images/l11520179494463.JPG"
    ],
    "video": ""
  },
  {
    "id": "23-nisan-ulusal-egemenlik-ve-cocuk-bayrami-kutlamalari",
    "title": "23 Nisan Ulusal Egemenlik ve Çocuk Bayramı Kutlamaları",
    "image": "/files/images/l2842017123252646.JPG",
    "description": "23 Nisan Ulusal Egemenlik ve Çocuk Bayramı Kutlamaları",
    "gallery": [
      "/files/images/l2842017123252646.JPG",
      "/files/images/l2842017123352115.JPG",
      "/files/images/l2842017123352584.JPG",
      "/files/images/l2842017123452115.JPG",
      "/files/images/l2842017123452599.JPG",
      "/files/images/l284201712355299.jpg",
      "/files/images/l2842017123552412.JPG",
      "/files/images/l2842017123552881.JPG",
      "/files/images/l2842017123652349.JPG",
      "/files/images/l2842017123652802.JPG",
      "/files/images/l2842017123752287.JPG",
      "/files/images/l2842017123952146.JPG",
      "/files/images/l2842017123952771.JPG",
      "/files/images/l2842017124052318.JPG",
      "/files/images/l28420171241526.JPG"
    ],
    "video": "https://www.youtube.com/embed/v_awaJS3UKw?ecver=1"
  },
  {
    "id": "chess-tournament",
    "title": "CHESS TOURNAMENT",
    "image": "/files/images/l194201723436646.jpg",
    "description": "CHESS TOURNAMENT",
    "gallery": [
      "/files/images/l194201723436646.jpg"
    ],
    "video": ""
  },
  {
    "id": "23-nisan-ulusal-egemenlik-ve-cocuk-bayrami-",
    "title": "23 Nisan Ulusal Egemenlik ve Çocuk Bayramı",
    "image": "/files/images/l22420172159274.jpg",
    "description": "23 Nisan Ulusal Egemenlik ve Çocuk Bayramı23 Nisan Ulusal Egemenlik ve Çocuk Bayramı'nı bu yılda birlikte kutluyoruz. Bayramımızı onurlandırmanızı bekliyoruz.",
    "gallery": [
      "/files/images/l22420172159274.jpg"
    ],
    "video": ""
  },
  {
    "id": "yazar-aydogan-yavasli-ile-soylesi-ve-imza-gunu-",
    "title": "Yazar Aydoğan Yavaşlı ile Söyleşi ve İmza Günü",
    "image": "/files/images/l1442017162023494.JPG",
    "description": "Yazar Aydoğan Yavaşlı ile Söyleşi ve İmza Günü14 Nisan Çarşamba günü \" Deniz Okula Gidiyor, Işık Hızıyla Mars'a Yolculuk, Kara Karga Dizisi, Kirli Bir Kedinin Günlüğü \" kitaplarının yazarı Aydoğan Yavaşlı öğrencilerimizl buluştu.  Yazarımızı keyifli sohbetiyle ağırlamaktan mutluluk duyduk.",
    "gallery": [
      "/files/images/l1442017162023494.JPG",
      "/files/images/l1442017162223212.JPG",
      "/files/images/l1442017162823197.JPG"
    ],
    "video": ""
  },
  {
    "id": "sergimizi-actik-sizleri-de-forum-avm-ye-bekliyoruz",
    "title": "SERGİMİZİ AÇTIK... SİZLERİ DE FORUM AVM YE BEKLİYORUZ..",
    "image": "/files/images/l342017225459440.jpg",
    "description": "SERGİMİZİ AÇTIK... SİZLERİ DE FORUM AVM YE BEKLİYORUZ..Sergimizi açtık... Sizleri de Forum AVM' ye bekliyoruz..",
    "gallery": [
      "/files/images/l342017225459440.jpg",
      "/files/images/l342017225459659.jpg",
      "/files/images/l34201722555934.jpg",
      "/files/images/l342017225559237.jpg",
      "/files/images/l342017225559424.jpg",
      "/files/images/l342017225559659.jpg",
      "/files/images/l342017225559863.jpg",
      "/files/images/l342017225659143.jpg",
      "/files/images/l342017225659393.jpg"
    ],
    "video": ""
  },
  {
    "id": "sira-nur-eroglu-50m-sirtustude-turkiye--1si-olmustur",
    "title": "Şira Nur EROĞLU 50m sırtüstüde Türkiye  1.si olmuştur",
    "image": "/files/images/l242017225734626.jpg",
    "description": "Şira Nur EROĞLU 50m sırtüstüde Türkiye  1.si olmuşturŞira Nur EROĞLU Çanakkale'de düzenlenen Anadolu Yıldızları yüzme final yarışmalarında; 200m karışıkta Türkiye 2.si, 50m sırtüstüde de Türkiye  1.si olmuştur.Öğrencimizi kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l242017225734626.jpg",
      "/files/images/l242017225734923.jpg"
    ],
    "video": ""
  },
  {
    "id": "-tenis--erkek-takimimiz-il-dorduncusu-oldu-",
    "title": "Tenis  Erkek Takımımız il dördüncüsü oldu.",
    "image": "/files/images/l243201716461471.jpg",
    "description": "Tenis  Erkek Takımımız il dördüncüsü oldu.Mersin Tenis Küçük Kız Takımımız ve Tenis Küçük Erkek Takımımız il dördüncüsü oldu. Öğrencilerimizi kutluyoruz.",
    "gallery": [
      "/files/images/l243201716461471.jpg",
      "/files/images/l2432017164614196.jpg"
    ],
    "video": ""
  },
  {
    "id": "-3--8--nisan-da-forumavm-de-bulusalim",
    "title": "3 - 8  NİSAN DA FORUMAVM DE BULUŞALIM...",
    "image": "/files/images/l2432017144258374.jpg",
    "description": "3 - 8  NİSAN DA FORUMAVM DE BULUŞALIM...3 - 8  NİSAN DA FORUMAVM DE BULUŞALIM",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c2432017145358858.jpg.jpg",
      "/files/images/l2432017144258374.jpg"
    ],
    "video": ""
  },
  {
    "id": "18-mart-canakkale-sehitlerini-anma-gunu",
    "title": "18 Mart Çanakkale Şehitlerini Anma Günü",
    "image": "/files/images/l2132017161826893.jpg",
    "description": "18 Mart Çanakkale Şehitlerini Anma Günü",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c1632017124446182.jpg.jpg",
      "/files/images/l1632017122846791.jpg"
    ],
    "video": ""
  },
  {
    "id": "18-mart-canakkale-sehitlerini-anma-gunu",
    "title": "18 Mart Çanakkale Şehitlerini Anma Günü",
    "image": "/files/images/l1632017122846791.jpg",
    "description": "18 Mart Çanakkale Şehitlerini Anma Günü",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c1632017124446182.jpg.jpg",
      "/files/images/l1632017122846791.jpg"
    ],
    "video": ""
  },
  {
    "id": "losev-e-destek-garaj-satislari",
    "title": "Lösev e destek garaj satışları",
    "image": "/files/images/l1032017121514605.jpg",
    "description": "Lösev e destek garaj satışları9 Aralık Cuma günü 2. El eşyaların satışının gerçekleştiği garaj satışlarından elde edilen gelir ile Mersin Üniversitesi hematoloji onkoloji bölümüne bağışımızı gerçekleştirdik.  Bağış yapan 14 öğrencilerimizle birlikte  hastaneye gezi düzenledik.",
    "gallery": [
      "/files/images/l1032017121514605.jpg",
      "/files/images/l1032017121514683.jpg",
      "/files/images/l1032017121514746.jpg"
    ],
    "video": ""
  },
  {
    "id": "losev-e-destek-garaj-satislari",
    "title": "Lösev e destek garaj satışları",
    "image": "/files/images/l1032017123711120.jpg",
    "description": "Lösev e destek garaj satışları9 Aralık Cuma günü 2. El eşyaların satışının gerçekleştiği garaj satışlarından elde edilen gelir ile Mersin Üniversitesi hematoloji onkoloji bölümüne bağışımızı gerçekleştirdik.  Bağış yapan 14 öğrencilerimizle birlikte  hastaneye gezi düzenledik.",
    "gallery": [
      "/files/images/l1032017121514605.jpg",
      "/files/images/l1032017121514683.jpg",
      "/files/images/l1032017121514746.jpg"
    ],
    "video": ""
  },
  {
    "id": "dunya-diyabet-gunu",
    "title": "Dünya diyabet günü",
    "image": "/files/images/l103201712130822.jpg",
    "description": "Dünya diyabet günü17 Kasım Perşembe günü diyabet ile ilgili bilgilendirme yapmak ve obeziteyle savaş konularını anlatmak üzere Uzman Çocuk Doktoru Nalan Deniz okulumuzda sunum yapmıştır. Ayrıca lösemili çocuklara yardım yapmak amacıyla lösev ile ilgili bilgilendirme yapılmıştır.",
    "gallery": [
      "/files/images/l103201712130822.jpg",
      "/files/images/l103201712130963.jpg",
      "/files/images/l10320171214010.jpg"
    ],
    "video": ""
  },
  {
    "id": "kasim-ayi-1-hafta-down-sendromlu-ogrencilerimiz-okulumuzu-ziyaret--etti",
    "title": "Kasım ayı 1. Hafta down sendromlu öğrencilerimiz okulumuzu ziyaret  etti",
    "image": "/files/images/l1032017111453306.jpg",
    "description": "Kasım ayı 1. Hafta down sendromlu öğrencilerimiz okulumuzu ziyaret  ettiDown sendorumlu öğrencilerimizle okul öğrencilerimizle atölyemizde ahşap çalışmaları yaparak birlikte olmanın keyfini yaşadık…",
    "gallery": [
      "/files/images/l1032017111453306.jpg",
      "/files/images/l1032017111453399.jpg",
      "/files/images/l1032017111453493.jpg",
      "/files/images/l1032017111453571.jpg",
      "/files/images/l1032017111453681.jpg",
      "/files/images/l1032017111453790.jpg",
      "/files/images/l1032017111453868.jpg",
      "/files/images/l1032017111453993.jpg",
      "/files/images/l1032017111553196.jpg"
    ],
    "video": ""
  },
  {
    "id": "gelisim-arkadaslik-haftasi",
    "title": "Gelişim Arkadaşlık Haftası",
    "image": "/files/images/l732017124124836.jpg",
    "description": "Gelişim Arkadaşlık HaftasıGelişim Arkadaşlık HaftasıGelişim Arkadaşlık Haftası’nda, arkadaşlık kavramını pekiştirmeyi, zorbalığın ne olduğu ve neden yapılmaması gerektiği konusunda farkındalık yaratmayı amaçladık. Bu hafta içerisinde; arkadaşlık bilekliği, arkadaşlık kartı, arkadaşlık çerçevesi gibi aktiviteler yaptık ve yaptıklarımızı arkadaşlarımıza hediye ettik. Hepimiz Çarşamba günü mavi giyindik ve “Zorbalığa hayır!” dedik. Derslerde rehberlik öğretmenlerimizle arkadaşlık üzerine sohbetler ettik ve arkadaşlıkla ilgili sloganlar belirleyerek sınıf afişleri tasarladık. “Zorba olma, arkadaş ol.” sloganıyla arkadaşlarımız ve öğretmenlerimizin katıldığı bir video çektik ve konferans salonunda bu videoyu hep birlikte izledik, öncesinde de okul psikoloğumuzun sunumunu dinledik. Anaokulundan liseye, öğretmenlerden personele kadar herkesin katıldığı bir arkadaşlık haftasını geride bıraktık ve çok eğlendik, eğlenirken de arkadaşlarımıza nasıl daha doğru yaklaşabileceğimizi öğrendik.",
    "gallery": [
      "/files/images/l732017124124836.jpg",
      "/files/images/l732017124124930.jpg",
      "/files/images/l7320171242248.jpg",
      "/files/images/l732017124224211.jpg",
      "/files/images/l732017124224290.jpg",
      "/files/images/l732017124224430.jpg",
      "/files/images/l732017124224571.jpg",
      "/files/images/l732017124224711.jpg",
      "/files/images/l732017124324415.jpg",
      "/files/images/l73201712442455.jpg",
      "/files/images/l732017124424227.jpg",
      "/files/images/l732017124424415.jpg",
      "/files/images/l732017124424508.jpg",
      "/files/images/l1432017103856369.jpg",
      "/files/images/l1432017103856447.jpg",
      "/files/images/l1432017103856526.jpg",
      "/files/images/l1432017103856604.jpg",
      "/files/images/l1432017103856744.jpg",
      "/files/images/l1432017103856838.jpg",
      "/files/images/l1432017103856901.jpg",
      "/files/images/l283201792310634.jpg"
    ],
    "video": "https://www.youtube.com/embed/fY76wCkTmrI?ecver=1"
  },
  {
    "id": "sivil-savunma-ve-yangin-haftasi",
    "title": "Sivil Savunma ve yangın haftası",
    "image": "/files/images/l632017165017118.jpg",
    "description": "Sivil Savunma ve yangın haftasıSivil Savunma ve yangın haftası dolayısı ile 6 Mart Pazartesi günü ortaokul bahçesinde itfaiye ekiplerinin yangın söndürme tatbikatı gerçekleştirilmiştir.Tatbikat öncesi yangın söndürme ile ilgili bilgi verilmiş sonra yakılan ateş yangın söndürücüler ile söndürülmüştür. Öğrencilerimizin de katılımıyla başarıyla sonuçlanan tatbikat için itfaiye ekiplerine teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l632017165017118.jpg",
      "/files/images/l632017165017384.jpg"
    ],
    "video": ""
  },
  {
    "id": "dunya-kadinlar-gunu--kamu-spotu",
    "title": "Dünya kadınlar Günü - Kamu Spotu",
    "image": "/files/images/l53201722462586.jpg",
    "description": "Dünya kadınlar Günü - Kamu Spotu",
    "gallery": [
      "/files/images/l53201722462586.jpg"
    ],
    "video": "https://www.youtube.com/embed/NjMbqj4tiBs?ecver=1"
  },
  {
    "id": "gelisim-koleji-yildiz-kiz-takimi",
    "title": "GELİSİM KOLEJI YILDIZ KIZ TAKIMI",
    "image": "/files/images/l41201795039339.jpg",
    "description": "GELİSİM KOLEJI YILDIZ KIZ TAKIMIGELİŞİM KOLEJİ YILDIZ KIZ TAKIMIMIZ FİNALDE. KIZLARIMIZA  BU ZORLU GRUPTA BAŞARILAR DİLİYORUZ.",
    "gallery": [
      "/files/images/l41201795039339.jpg"
    ],
    "video": ""
  },
  {
    "id": "gelisim-koleji-yildiz-kiz-voleybol-takimi-yarifinal-de",
    "title": "Gelişim Koleji Yıldız Kız Voleybol Takımı Yarıfinal de",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Gelişim Koleji Yıldız Kız Voleybol Takımı Yarıfinal deGelişim Koleji Yıldız Kız Voleybol Takımı Yarı final deGelişim Koleji Yıldız Kız Voleybol Takımı",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/files/2212201611522491.jpg"
    ],
    "video": ""
  },
  {
    "id": "-voleybol-yildiz-kiz-takimimiz-grup-birincisi-olarak-2tura-ciktilar",
    "title": "Voleybol Yıldız Kız Takımimiz grup birincisi olarak 2.tura çıktılar",
    "image": "/files/images/l15122016101747644.jpeg",
    "description": "Voleybol Yıldız Kız Takımimiz grup birincisi olarak 2.tura çıktılarOkulsporlarında Voleybol Yıldız Kız Takımimiz grup birincisi olarak 2.tura çıktılar. Kızlarımızı kutluyor başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l15122016101747644.jpeg",
      "/files/images/l15122016101747847.jpeg",
      "/files/images/l15122016101747988.jpeg"
    ],
    "video": ""
  },
  {
    "id": "ogretmenler-gunu",
    "title": "ÖĞRETMENLER GÜNÜ",
    "image": "/files/images/l2211201610048791.jpg",
    "description": "ÖĞRETMENLER GÜNÜ",
    "gallery": [
      "/files/images/l2411201792536952.png"
    ],
    "video": ""
  },
  {
    "id": "yeni-web-adresimiz",
    "title": "YENİ WEB ADRESİMİZ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "YENİ WEB ADRESİMİZYENİ WEB SİTESİ ADRESİMİZ İÇİN LÜTFEN TIKLAYINIZ",
    "gallery": [],
    "video": ""
  },
  {
    "id": "duyuru",
    "title": "DUYURU..",
    "image": "/images2/img2_files/logo.jpg",
    "description": "DUYURU..",
    "gallery": [],
    "video": ""
  },
  {
    "id": "acilis-toreni",
    "title": "AÇILIŞ TÖRENİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "AÇILIŞ TÖRENİGüney Gelişim Okulları, 16. yılında bünyesine eklediği Anadolu Lisesiyle, eğitim alanında hizmetlerine devam ediyor.Protokol üyeleri ve velilerimizin yoğun katılımıyla, çoşkuyla gerçekleşen Açılış Töreninde Okul Müdürümüz Filiz Budur  Gelişim Okullarının kuruluş amacı ve başarılarından söz etti.Vali Yardımcısı Sayın Eyüp Sabri Kartal , Yenişehir  Kaymakamı Sayın Dr. Mustafa Özarslan, İl Milli Eğitim Müdürü Sayın Adem Koca, İlçe Milli Eğitim Müdürü Sayın Kamil Çelebiyılmaz da yaptıkları konuşmalarla eğitimin önemini ve Güney Gelişim Okullarının eğitim alanındaki hizmetlerini, başarılarını anlattılar.Hakan Ali Toker ve Zafer Mutlu da muhteşem piyano resitali ve şan konseriyle açılışımıza renk kattı.Bu özel günümüzde, konuğumuz olan herkese çok teşekkür ediyoruz.",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/k3gCqWNjenYT3wdkUVz"
  },
  {
    "id": "123-sinif-kahvaltimiz",
    "title": "1.,2.,3. SINIF KAHVALTIMIZ...",
    "image": "/files/images/t_21._9024164080.jpg",
    "description": "1.,2.,3. SINIF KAHVALTIMIZ...1.,2.,3. sınıf velilerimiz ve öğrencilerimizle okul bahçesinde yaptığımız \"Kahvaltı Etkinliği\" güzel geçti. 2015 - 2016 hedeflerimizi, etkinliklerimizi paylaştığımız sohbetler de çok keyifliydi. İşte bu güzel günümüzden görüntüler...",
    "gallery": [
      "/files/images/t_21._9024164080.jpg",
      "/files/images/t_20._443994403.jpg",
      "/files/images/t_18._9263116717.jpg",
      "/files/images/t_17._6952630877.jpg",
      "/files/images/t_16._8134118914.jpg",
      "/files/images/t_15._3692438007.jpg",
      "/files/images/t_14._6103631854.jpg",
      "/files/images/t_13._8906366229.jpg",
      "/files/images/t_12._5725671649.jpg",
      "/files/images/t_11._5927698016.jpg",
      "/files/images/t_10._9901544451.jpg",
      "/files/images/t_9.j_2831384540.jpg",
      "/files/images/t_8.j_329706073.jpg",
      "/files/images/t_7.j_4669000506.jpg",
      "/files/images/t_7.j_2747003436.jpg",
      "/files/images/t_6.j_2581598163.jpg",
      "/files/images/t_5.j_9152643084.jpg",
      "/files/images/t_4.j_5871393084.jpg",
      "/files/images/t_3.j_6132776141.jpg",
      "/files/images/t_2.j_6163293719.jpg",
      "/files/images/t_1.j_7330591082.jpg"
    ],
    "video": ""
  },
  {
    "id": "teog-yerlestirme-sonuclarimiz",
    "title": "TEOG YERLEŞTİRME SONUÇLARIMIZ",
    "image": "/files/images/t_aa._4025232196.jpg",
    "description": "TEOG YERLEŞTİRME SONUÇLARIMIZTEOG YERLEŞTİRME SONUÇLARIMIZ AŞAĞIDA LİNKTEDİR...",
    "gallery": [
      "/files/images/t_aa._4025232196.jpg"
    ],
    "video": ""
  },
  {
    "id": "2015--2016-egitim-ogretim-destegi-e--klavuzu",
    "title": "2015 - 2016 EĞİTİM ÖĞRETİM DESTEĞİ e - KLAVUZU",
    "image": "/files/images/t_1.j_387231708.jpg",
    "description": "2015 - 2016 EĞİTİM ÖĞRETİM DESTEĞİ e - KLAVUZU2015 - 2016 DÖNEMİ EĞİTİM - ÖĞRETİM DESTEĞİ UYGULAMA  e - KLAVUZU",
    "gallery": [
      "/files/images/t_1.j_387231708.jpg",
      "/files/images/t_2.j_6591760516.jpg",
      "/files/images/t_3.j_9626886248.jpg",
      "/files/images/t_4.j_7243921160.jpg",
      "/files/images/t_5.j_1185724140.jpg",
      "/files/images/t_6.j_7750818133.jpg",
      "/files/images/t_7.j_5207940936.jpg",
      "/files/images/t_8.j_5048028827.jpg",
      "/files/images/t_9.j_6388666034.jpg",
      "/files/images/t_10._9081384539.jpg",
      "/files/images/t_11._8351404071.jpg"
    ],
    "video": ""
  },
  {
    "id": "altin-kiz-sira-nur-eroglu",
    "title": "ALTIN KIZ ŞİRA NUR EROĞLU",
    "image": "/files/images/t_IMG_1851770282.jpg",
    "description": "ALTIN KIZ ŞİRA NUR EROĞLUAltın Kız Şira Nur Eroğlu \"Mersin Okul Sporlarında\" girdiği  tüm yüzme branşlarında 1. olarak madalyaları topladı. Öğrencimizi kutluyoruz.",
    "gallery": [
      "/files/images/t_IMG_1851770282.jpg"
    ],
    "video": ""
  },
  {
    "id": "muzik-bolumu-duyurusu",
    "title": "MÜZİK BÖLÜMÜ DUYURUSU",
    "image": "/images2/img2_files/logo.jpg",
    "description": "MÜZİK BÖLÜMÜ DUYURUSUSayın Velimiz,Sene başından beri azimle çalışan Polifonik Koromuz, Müzik Kulübümüz,Okul Müzik Grubumuz3 Haziran Çarşamba Günüperformanslarını sahneleyecekler.3 Haziran Çarşamba GünüPolifonik KoroveMüzik Kulübüöğrencileri okul çıkışı evlerineServislerle gidecek, 17.45 ‘de aileleri ile okula geleceklerdir.Müzik Grubuöğrencileri ise kıyafetlerini yanlarında getirip okulda kalacaklar, dönüşte de aileleri tarafından alınacaklardır.Siz velilerimizi heyecanımızı paylaşmaya davet ediyoruz…Yer   :  Gelişim Koleji Konser SalonuTarih: 3 Haziran Çarşamba GünüSaat  :  17.45NOT: Polifonik Koron öğrencilerinin kıyafetleri:Kot pantolon, Bluz( pembe, yeşil, sarı), Spor ayakkabıMüzik Kulübü öğrencilerinin kıyafetleri:Kot pantolon, Tek renk bluz, Spor ayakkabıMüzik Grubu öğrencilerinin kıyafetleri:Siyah pantolon, Atatürk tişörtü, Spor ayakkabıEZGİ ERDOĞANMÜZİK ÖĞRETMENİ",
    "gallery": [],
    "video": ""
  },
  {
    "id": "kitap-fuari",
    "title": "KİTAP FUARI",
    "image": "/files/images/t_DSC_1496850849.jpg",
    "description": "KİTAP FUARI5. ve. 6. sınıf öğrencilerimiz Marina'daki kitap fuarina düzenlediğimiz geziyle kitaplarla iç içe olmanin,kendi seçtikleri kitapları almanın zevkini ve mutluluğunu yaşadılar.",
    "gallery": [
      "/files/images/t_DSC_1496850849.jpg",
      "/files/images/t_DSC_2272149921.jpg",
      "/files/images/t_DSC_4613305926.jpg",
      "/files/images/t_DSC_5621454120.jpg",
      "/files/images/t_DSC_4860193133.jpg",
      "/files/images/t_DSC_7835199237.jpg",
      "/files/images/t_DSC_1043359638.jpg",
      "/files/images/t_DSC_3156854510.jpg",
      "/files/images/t_DSC_6029321551.jpg",
      "/files/images/t_DSC_987054706.jpg",
      "/files/images/t_DSC_2149927020.jpg"
    ],
    "video": ""
  },
  {
    "id": "gitar-resitali",
    "title": "GİTAR RESİTALİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "GİTAR RESİTALİ",
    "gallery": [],
    "video": ""
  },
  {
    "id": "festival-duyurusu",
    "title": "FESTİVAL DUYURUSU",
    "image": "/images2/img2_files/logo.jpg",
    "description": "FESTİVAL DUYURUSUSene \tbaşından beri azimle çalışan koromuz performanslarını Mersin \tNevit Kodallı Çoksesli Korolar Festivali'nde sahneleyecektir.Öğrencilerimiz \t,kültür merkezineokulumuzdan kalkacak servisler ile götürülecektir. Koromuz ,16.00 seansında 2. sıradasahneye çıkacak , etkinlik \tsonunda öğrencilerimiz aileleri tarafından alınacaktır.Siz \tvelilerimizi heyecanımızı paylaşmaya davet ediyoruz...Yer: Mersin Kültür MerkeziTarih: 15 Mayıs Cuma Günü (15.05.2015)Saat :16.00NOT: Koro kıyafetleri : Mavi Kot pantolon,Spor ayakkabı,polo yaka bluz( Her öğrencinin hangi renk giyeceği bellidir; toz pembe,elma yeşili,açık sarı )EZGİ ERDOĞANMÜZİK ÖĞRETMENİ",
    "gallery": [],
    "video": ""
  },
  {
    "id": "genel-tanitim-toplantisi",
    "title": "GENEL TANITIM TOPLANTISI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "GENEL TANITIM TOPLANTISI",
    "gallery": [],
    "video": ""
  },
  {
    "id": "kutay-bartu-ozbek-karakalem---naturmort-sergisi",
    "title": "KUTAY BARTU ÖZBEK KARAKALEM   NATÜRMORT SERGİSİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "KUTAY BARTU ÖZBEK KARAKALEM   NATÜRMORT SERGİSİ",
    "gallery": [],
    "video": ""
  },
  {
    "id": "gitar-resitali",
    "title": "GİTAR RESİTALİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "GİTAR RESİTALİ",
    "gallery": [],
    "video": ""
  },
  {
    "id": "okullar-arasi-tenis-turnuvasinda-birinciyiz",
    "title": "OKULLAR ARASI TENİS TURNUVASINDA BİRİNCİYİZ",
    "image": "/files/images/t_fot_2539026141.JPG",
    "description": "OKULLAR ARASI TENİS TURNUVASINDA BİRİNCİYİZ2014 - 2015 Okullar arası tenis turnuvasında 1. olan tenis takımımızı kutluyor, başarılarının devamını diliyoruz.TEBRİKLER TOPRAK AVCIBAŞITEBRİKLER BEKİR CAN ARACI",
    "gallery": [
      "/files/images/t_fot_2539026141.JPG",
      "/files/images/t_fot_6185113788.JPG"
    ],
    "video": ""
  },
  {
    "id": "see-you-in-finland-in-may",
    "title": "SEE YOU IN FINLAND IN MAY",
    "image": "/images2/img2_files/logo.jpg",
    "description": "SEE YOU IN FINLAND IN MAYFinlandiya’ dan haber… Mayıs ayında bizi dört gözle bekliyorlar.Erasmus+ Finland",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/k3rliBXzWsfPKAaC1SM"
  },
  {
    "id": "8-mart-“dunya-kadinlar-gunu”-satranc-turnuvasi",
    "title": "8 MART “DÜNYA KADINLAR GÜNÜ” SATRANÇ TURNUVASI",
    "image": "/files/images/t_DSC_7176477313.jpg",
    "description": "8 MART “DÜNYA KADINLAR GÜNÜ” SATRANÇ TURNUVASI8 MART “DÜNYA KADINLAR GÜNÜ” SATRANÇ TURNUVASI“Dünya Kadınlar Günü”nü ve bu gün nedeniyle Mersin Üniversitesinde düzenlenen Turnuvaya katılarak başarılı olan öğrencilerimizi kutluyoruz.ÖDÜLLER2005 DOĞUMLULLAR2006 DOĞUMLULAR2007 DOĞUMLULAR2008 DOĞUMLULAR2. Derin Ahmet Şifan                              3. İlker Özel                                      3. Irmak Alpsoylu                                   Yiğit Köprülü3. Mehmet Eren Yüzükçü                      Deniz Eren Özer                                     Bora Kurt                                        Ali Emre YüzükçüÖmer Tutku Tura                                  Tuğra Bilgin                                             Rüya Çelik                                      Bade TütüncüUtku Yiğit Yazıcı                                    Efe Ahmetler                                          Aydın Altar Güvenoğlu                  Berra Selen BüberMehmet Eren Kahrıman                        Barış Saygı                                              Sarp Yılmaz                                    Utku Eren TürközNehir Duru Öztürk                                Atanur Tancıl                                           Demir Halis Demir                          Umut Cem ÇiçekGüney Erdinç                                           Kuzey Çakıcı                                   Rüzgar Efe YıldırımKendal Zana AlpErdem Çöl                                        Ahmet Efe ÇelikElif YavrutürkCansu BoyarOğuz Kağan ÖzbayrakFurkan AslanHasan YozgatArda Ural",
    "gallery": [
      "/files/images/t_DSC_7176477313.jpg",
      "/files/images/t_DSC_1162988544.jpg",
      "/files/images/t_DSC_8618127703.jpg"
    ],
    "video": ""
  },
  {
    "id": "satranc-turnuvasi",
    "title": "SATRANÇ TURNUVASI",
    "image": "/files/images/t_IMG_9331170916.jpg",
    "description": "SATRANÇ TURNUVASIMersin Vergi Dairesi tarafından organize edilen \"Vergi Haftası Satranç Turnuvası\"nda 2-A sınıfı öğrencimiz Aydın Altar Güvenoğlu Mersin 3.sü oldu. Öğrencimizi kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_IMG_9331170916.jpg",
      "/files/images/t_IMG_9082452654.jpg"
    ],
    "video": ""
  },
  {
    "id": "yrddocdr-snertugrul-godelek-sunumu",
    "title": "Yrd.Doç.Dr. Sn.Ertuğrul Gödelek Sunumu",
    "image": "/files/images/t_DSC_1957208515.jpg",
    "description": "Yrd.Doç.Dr. Sn.Ertuğrul Gödelek Sunumu28.02.2015 Cumartesi günü Yrd.Doç.Dr. Sn.Ertuğrul Gödelek tarafından okulumuz konferans salonunda   sunulan ‘Çocuğum Teknolojiyi Nasıl Doğru Kullanabilir?’ konulu seminer velilerimizin katılımıyla gerçekleşmiştir.Seminerimize katılan velilerimize teşekkür ederiz.",
    "gallery": [
      "/files/images/t_DSC_1957208515.jpg",
      "/files/images/t_DSC_6481439471.jpg",
      "/files/images/t_DSC_9452478289.jpg",
      "/files/images/t_DSC_5917474627.jpg"
    ],
    "video": ""
  },
  {
    "id": "duyuru",
    "title": "DUYURU",
    "image": "/images2/img2_files/logo.jpg",
    "description": "DUYURU2014 – 2015 Eğitim – Öğretim yılında yapılan “Veli Memnuniyet Anketi” değerlendirme sonuçlarımıza K12 veli bilgilendirme sisteminden ulaşabilirsiniz.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "kucuk-kiz-voleybol-takimimiz-ilk-galibiyetini-aldi",
    "title": "KÜÇÜK KIZ VOLEYBOL TAKIMIMIZ İLK GALİBİYETİNİ ALDI.",
    "image": "/files/images/t_201_6932794452.jpg",
    "description": "KÜÇÜK KIZ VOLEYBOL TAKIMIMIZ İLK GALİBİYETİNİ ALDI.Küçük Kız Voleybol takımımız ilk galibiyetlerini aldı. Kızlarımızı tebrik eder diğer maçlarında da başarılar diliyoruz.",
    "gallery": [
      "/files/images/t_201_6932794452.jpg",
      "/files/images/t_201_3382684589.jpg"
    ],
    "video": ""
  },
  {
    "id": "teog-sinav-sonuclarimiz",
    "title": "TEOG SINAV SONUÇLARIMIZ",
    "image": "/files/images/t_11._4132348895.jpg",
    "description": "TEOG SINAV SONUÇLARIMIZ",
    "gallery": [
      "/files/images/t_11._4132348895.jpg",
      "/files/images/t_1.j_7114526629.jpg"
    ],
    "video": ""
  },
  {
    "id": "voleybolcu-kizlarimiz-sampiyonluga-adim-adim-yaklasiyor",
    "title": "VOLEYBOLCU KIZLARIMIZ ŞAMPİYONLUĞA ADIM ADIM YAKLAŞIYOR...",
    "image": "/files/images/t_1.j_7706109881.jpg",
    "description": "VOLEYBOLCU KIZLARIMIZ ŞAMPİYONLUĞA ADIM ADIM YAKLAŞIYOR...Voleybol Yıldız Takımı kızlarımız Huzurkent Atatürk Ortaokulu'ndan sonra Cengiz Topel Ortaokulunu'da 2-0 yenerek şampiyonluğa bir adım daha yaklaştılar.Kızlarımıza başarılar diliyoruz.",
    "gallery": [
      "/files/images/t_1.j_7706109881.jpg",
      "/files/images/t_3.j_9552423358.jpg",
      "/files/images/t_a.j_2586480975.jpg"
    ],
    "video": ""
  },
  {
    "id": "5-siniflar-antalya-side-kampi-4-gunumuzden-kareler",
    "title": "5. SINIFLAR ANTALYA SİDE KAMPI 4. GÜNÜMÜZDEN KARELER",
    "image": "/images2/img2_files/logo.jpg",
    "description": "5. SINIFLAR ANTALYA SİDE KAMPI 4. GÜNÜMÜZDEN KARELERANTALYApaylaşan:dm_51f91a1f906b4",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/k2qFbLE4vbYEGh9AK5r"
  },
  {
    "id": "5-siniflar-antalya-kampi-3gun",
    "title": "5. SINIFLAR ANTALYA KAMPI 3.GÜN",
    "image": "/images2/img2_files/logo.jpg",
    "description": "5. SINIFLAR ANTALYA KAMPI 3.GÜN3.GÜNpaylaşan:dm_51f91a1f906b4",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/k2eou65IHRqtlM9A9oi"
  },
  {
    "id": "5siniflar-antalya-kampi-2gunumuzden-kareler",
    "title": "5.SINIFLAR ANTALYA KAMPI 2.GÜNÜMÜZDEN KARELER",
    "image": "/images2/img2_files/logo.jpg",
    "description": "5.SINIFLAR ANTALYA KAMPI 2.GÜNÜMÜZDEN KARELERANTALYA 2.GÜNpaylaşan:dm_51f91a1f906b4",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/k34pqtoivKUx939zxjY"
  },
  {
    "id": "5siniflar-antalya-kampi",
    "title": "5.SINIFLAR ANTALYA KAMPI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "5.SINIFLAR ANTALYA KAMPIANNTALYA 1.GÜNNpaylaşan:dm_51f91a1f906b4",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/k4Ky4djYIk8kpv9yYiG"
  },
  {
    "id": "mersin-satranc-sampiyonasi",
    "title": "MERSİN SATRANÇ ŞAMPİYONASI",
    "image": "/files/images/t_DSC_7393762469.jpg",
    "description": "MERSİN SATRANÇ ŞAMPİYONASIYaş Grupları Mersin Şampiyonasında dereceye giren öğrencilerimizi kutluyor, başarılarının devamını diliyoruz.DERECEYE GİREN ÖĞRENCİLERİMİZ8 YAŞ GENELAYDIN ALTAR GÜVENOĞLUMERSİN 4. 'sü8 YAŞ KIZLARIRMAK ALPSOYLUMERSİN 3.",
    "gallery": [
      "/files/images/t_DSC_7393762469.jpg",
      "/files/images/t_DSC_8638269305.jpg",
      "/files/images/t_DSC_1336480976.jpg",
      "/files/images/t_DSC_6405908465.jpg"
    ],
    "video": ""
  },
  {
    "id": "10-kasim-ataturk`u-anma-gunu",
    "title": "10 KASIM ATATÜRK`Ü ANMA GÜNÜ",
    "image": "/files/images/t_1.j_8869897723.jpg",
    "description": "10 KASIM ATATÜRK`Ü ANMA GÜNÜAta'mızı aramızdan ayrılışının 76. yılında saygı, sevgi ve özlemle andık.Öğrencilerimizin özenle hazırladığı Anma Programını velilerimizin de yoğun katılımıyla gerçekleştirdik. Programımızın sonunda, hep beraber seslendirdiğimiz gibi:Atatürk'üm !\" Bu Kalp Seni Unutur mu ? \"",
    "gallery": [
      "/files/images/t_1.j_8869897723.jpg",
      "/files/images/t_2.j_9869806170.jpg",
      "/files/images/t_3.j_5779687762.jpg",
      "/files/images/t_4.j_691491962.jpg",
      "/files/images/t_5.j_8339502215.jpg",
      "/files/images/t_6.j_8236657977.jpg",
      "/files/images/t_7.j_9050409197.jpg",
      "/files/images/t_8.j_9203760027.jpg",
      "/files/images/t_9.j_5181390643.jpg",
      "/files/images/t_10._3702508807.jpg",
      "/files/images/t_11._3607599139.jpg",
      "/files/images/t_12._8838159442.jpg",
      "/files/images/t_15._1260492206.jpg",
      "/files/images/t_16._3895074725.jpg",
      "/files/images/t_17._3823511005.jpg",
      "/files/images/t_18._8611413836.jpg"
    ],
    "video": "http://www.dailymotion.com/embed/video/k25Bst2w3l7YxX9j9xI"
  },
  {
    "id": "eco-school-etkinligi",
    "title": "ECO SCHOOL ETKİNLİĞİ",
    "image": "/files/images/t_DSC_1129266620.jpg",
    "description": "ECO SCHOOL ETKİNLİĞİ“ECO SCHOLL” etkinlikleri çerçevesinde okulumuz öğrencileriyle Yenişehir Belediyesi Temizlik İşleri Daire başkanlığını ziyaret ederek çöp araçlarının üzerine öğrencilerimizin yaptığı “çevre ve doğa” konulu resimlerin asılması suretiyle insanlarda temiz bir çevre konusunda duyarlılık oluşturmayı amaçladık.",
    "gallery": [
      "/files/images/t_DSC_1129266620.jpg",
      "/files/images/t_DSC_5793268084.jpg",
      "/files/images/t_DSC_4968683124.jpg",
      "/files/images/t_DSC_4204675555.jpg",
      "/files/images/t_DSC_3049890399.jpg",
      "/files/images/t_DSC_7590753436.jpg",
      "/files/images/t_DSC_7968561053.jpg"
    ],
    "video": ""
  },
  {
    "id": "basketbolda-lideriz",
    "title": "BASKETBOLDA LİDERİZ",
    "image": "/files/images/t_DSC_852929950.jpg",
    "description": "BASKETBOLDA LİDERİZGelişim Okulları Spor Kulübümüzün, \"Basketbol Küçük Erkekler\" kategorisindeki takımımız, oynadıkları ilk iki maçı farklı skorlarla kazanarak liderliğe yükselmiştir.Sporcularımızı kutluyor bundan sonraki maçlarda da başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_DSC_852929950.jpg",
      "/files/images/t_DSC_6170160174.jpg"
    ],
    "video": ""
  },
  {
    "id": "cumhuriyet-bayrami-kosu-birincilerimiz",
    "title": "CUMHURİYET BAYRAMI KOŞU BİRİNCİLERİMİZ",
    "image": "/files/images/t_201_9090844988.jpg",
    "description": "CUMHURİYET BAYRAMI KOŞU BİRİNCİLERİMİZBağışıklık sistemini geliştiren, dikkat ve konsantrasyon gücünü yükselten kısa mesafe koşu yarışmalarında birinci olan öğrencilerimizi kutluyoruz.‏",
    "gallery": [
      "/files/images/t_201_9090844988.jpg"
    ],
    "video": ""
  },
  {
    "id": "polifonik-koromuz",
    "title": "POLİFONİK KOROMUZ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "POLİFONİK KOROMUZ",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/k6H9yNdtnlo7SU9eNxd"
  },
  {
    "id": "",
    "title": "",
    "image": "/files/images/t_T.j_1723749042.jpg",
    "description": "",
    "gallery": [],
    "video": ""
  },
  {
    "id": "gelisim-koleji-mezunlari-bulustu",
    "title": "GELİŞİM KOLEJİ MEZUNLARI BULUŞTU..",
    "image": "/files/images/t_DSC_4210931659.jpg",
    "description": "GELİŞİM KOLEJİ MEZUNLARI BULUŞTU..6 Eylül 2014 'te mezunlarımız ve aileleriyle keyifli bir sabah kahvaltısı geçirdik. Mezunlarımız ve Gelişim Koleji ailesi eski günleri yad edip, Gelişim Koleji'nin havasını tekrar soludular.Katılan tüm öğrenci ve velilerimize teşekkür ediyoruz. Bu yıl ilkini yaptığımız ve gelenekselleştirmek istediğimiz mezunlar kahvaltısında tekrar buluşmak dileğiyle...",
    "gallery": [
      "/files/images/t_DSC_4210931659.jpg",
      "/files/images/t_DSC_9563409686.jpg",
      "/files/images/t_DSC_8866693377.jpg",
      "/files/images/t_DSC_417749286.jpg",
      "/files/images/t_DSC_5617944598.jpg",
      "/files/images/t_DSC_6660119891.jpg",
      "/files/images/t_DSC_8194391131.jpg",
      "/files/images/t_DSC_6523706317.jpg",
      "/files/images/t_DSC_8279687762.jpg",
      "/files/images/t_DSC_2480432391.jpg"
    ],
    "video": ""
  },
  {
    "id": "teog-yerlestirme-sonucu",
    "title": "teog yerleştırme sonucu",
    "image": "/files/images/t_YER_6446649432.jpg",
    "description": "teog yerleştırme sonucuTEOG YERLEŞTİRME SONUÇLARIMIZ EKTEDİR.",
    "gallery": [
      "/files/images/t_YER_6446649432.jpg"
    ],
    "video": ""
  },
  {
    "id": "kahvalti-etkinligi",
    "title": "KAHVALTI ETKİNLİĞİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "KAHVALTI ETKİNLİĞİ13 Eylül 2014 cumartesi günü 1.,2. ve 3. sınıföğrenci ve velilerimizi saat 10:00 da başlayacak olan kahvaltı etkinliğimize bekliyoruz.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "profdr-irfan-erdogan",
    "title": "PROF.DR İRFAN ERDOĞAN",
    "image": "/files/images/t_dav_5688897967.jpg",
    "description": "PROF.DR İRFAN ERDOĞAN",
    "gallery": [
      "/files/images/t_dav_5688897967.jpg"
    ],
    "video": ""
  },
  {
    "id": "egitim--ogretim-destegi",
    "title": "EĞİTİM - ÖĞRETİM DESTEĞİ",
    "image": "/files/images/t_1.j_8580591082.jpg",
    "description": "EĞİTİM - ÖĞRETİM DESTEĞİRESİMLERİ TIKLAYINIZ...",
    "gallery": [
      "/files/images/t_1.j_8580591082.jpg",
      "/files/images/t_2.j_4036065936.jpg",
      "/files/images/t_3.j_6848718524.jpg",
      "/files/images/t_Unt_4977380633.jpg",
      "/files/images/t_12._5270959735.jpg",
      "/files/images/t_aa._6938287616.jpg"
    ],
    "video": ""
  },
  {
    "id": "2013--2014-egitim-ogretim-yili-8-sinif-ogrencilerimizin-teog-sonuclari",
    "title": "2013 - 2014 EĞİTİM ÖĞRETİM YILI 8. SINIF ÖĞRENCİLERİMİZİN TEOG SONUÇLARI",
    "image": "/files/images/t_teo_2825586200.jpg",
    "description": "2013 - 2014 EĞİTİM ÖĞRETİM YILI 8. SINIF ÖĞRENCİLERİMİZİN TEOG SONUÇLARIADI SOYADIYEP                           (Yerleştirme esas   puan)Yüzdelik dilim il   geneliYüzdelik dilim Türkiye   geneliZEYNEP ERKAL493,30,130,17EREN BUDUR490,00,290,39ELİF   DEMİRKOL482,60,971,08EKİN DOĞA   İNAM479,41,371,44BENAN GÜÇBEY478,31,511,57YASEMİN   KARAMAYA471,52,392,42KEREM TARCAN470,32,622,58DUYGU GÖKHAN468,22,882,86BURÇ BULUKLU466,93,083,05LAL YILDIRAN464,73,43,36SAMET YARKIN   ÖZANANAR459,64,124,08MERT TARIK   ÇİFTÇİ457,34,524,41ETHEM MERT   ÇAVUŞOĞLU446,66,386,04CAN   ÇİFTÇİOĞLU437,78,027,5SOLİN ARAP437,18,167,61BERSU   TEKİNALP431,19,378,66CLAUDİA KONAR428,79,829,05HALİL ASRIN   ATABAY428,69,849,08TUNA   AHMETLER409,513,9212,67DEFNE   MELİSA  BİÇER407,814,2913,05ALEX KONAR342,331,6229,86HAKKI BAYBARS   TAYYİPOĞLU340,232,2930,54ŞEVDER   AYDEMİR331,635,1933,34",
    "gallery": [
      "/files/images/t_teo_2825586200.jpg"
    ],
    "video": ""
  },
  {
    "id": "gelisim-koleji-mezunlari-bulusuyor",
    "title": "GELİŞİM KOLEJİ MEZUNLARI BULUŞUYOR",
    "image": "/images2/img2_files/logo.jpg",
    "description": "GELİŞİM KOLEJİ MEZUNLARI BULUŞUYORSizleri Özledik...Gelenekselleştirmek istediğimiz\"Mezunlar Günü\"müze tüm mezunlarımızı aileleriyle birlikte6 Eylül 2014 Cumartesigünü saat10.00'daokul bahçemizde yapacağımız kahvaltıya bekliyoruz.NOT: Katılacak mezunlarımızın kaç kişi olarak katılacaklarını0 530 371 97 36numaralı okul telefonuna bildirmelerini rica ederiz.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "yaz-kampi-muzik",
    "title": "YAZ KAMPI MÜZİK",
    "image": "/images2/img2_files/logo.jpg",
    "description": "YAZ KAMPI MÜZİK",
    "gallery": [],
    "video": "http://www.youtube.com/embed/PqjobedOiIg?list=UUBVGWFCMvJWs5p6noJK4dng"
  },
  {
    "id": "polifonik-koro",
    "title": "POLİFONİK KORO",
    "image": "/files/images/t_DSC_3964502215.jpg",
    "description": "POLİFONİK KORO2013-2014 Eğitim Öğretim yılı boyunca koro çalışmalarımıza azimle katılan ve performansları ile bizleri gururlandıran “Polifonik Koro” öğrencilerimizle 10.06.2014 Salı Günü öğle arasında Marina Burger King ‘de başarımızı kutladık.",
    "gallery": [
      "/files/images/t_DSC_3964502215.jpg",
      "/files/images/t_DSC_8179437518.jpg",
      "/files/images/t_DSC_1494562030.jpg",
      "/files/images/t_DSC_8815576434.jpg",
      "/files/images/t_DSC_3218500018.jpg"
    ],
    "video": ""
  },
  {
    "id": "basketbol-il-birinciligi",
    "title": "BASKETBOL İL BİRİNCİLİĞİ",
    "image": "/files/images/t_DSC_165216327.jpg",
    "description": "BASKETBOL İL BİRİNCİLİĞİ2013-2014 yılı il birincisi olan  Minik Erkekler Basketbol takımımızı kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_DSC_165216327.jpg",
      "/files/images/t_DSC_2609521747.jpg",
      "/files/images/t_DSC_9975854754.jpg",
      "/files/images/t_DSC_3005945087.jpg"
    ],
    "video": ""
  },
  {
    "id": "mezuniyet-gecesi",
    "title": "MEZUNİYET GECESİ",
    "image": "/files/images/t_DSC_7158624530.jpg",
    "description": "MEZUNİYET GECESİKep töreninin ardından yapılan mezuniyet gecemizde öğretmenlerimiz, velilerimiz ve öğrencilerimiz bütün bir yılın yorgunluğunu attılar. Mezun olmanın verdiği gurur bütün öğrencilerimizin gözlerine yansımıştı. Hep birlikte bir gelişim ailesi olarak öğrencilerimizin mezuniyetini çoşkuyla kutladık.",
    "gallery": [
      "/files/images/t_DSC_7158624530.jpg",
      "/files/images/t_DSC_9368707537.jpg",
      "/files/images/t_DSC_868493915.jpg"
    ],
    "video": ""
  },
  {
    "id": "mezuniyet-toreni",
    "title": "MEZUNİYET TÖRENİ",
    "image": "/files/images/t_1.j_4261438251.jpg",
    "description": "MEZUNİYET TÖRENİGelişim Koleji ailesi olarak düzenlediğimiz kep töreni bizim için hem ayrılmanın verdiği hüzün hem de gururla dolu olduğumuz bir sevincin gecesi oldu. Mezun olan öğrencilerimize başarıyla dolu bir gelecek diliyoruz.",
    "gallery": [
      "/files/images/t_1.j_4261438251.jpg",
      "/files/images/t_2.j_8084070086.jpg",
      "/files/images/t_3.j_779535175.jpg",
      "/files/images/t_4.j_7382318377.jpg",
      "/files/images/t_5.j_4234125018.jpg",
      "/files/images/t_6.j_7922174334.jpg",
      "/files/images/t_7.j_6937219500.jpg",
      "/files/images/t_7.j_5506097674.jpg",
      "/files/images/t_8.j_9293481707.jpg",
      "/files/images/t_9.j_8953058123.jpg"
    ],
    "video": ""
  },
  {
    "id": "babalar-gunu-satranc-turnuvasi",
    "title": "BABALAR GÜNÜ SATRANÇ TURNUVASI",
    "image": "/files/images/t_New_8362542987.jpg",
    "description": "BABALAR GÜNÜ SATRANÇ TURNUVASIB&S Yatırım A.Ş. katkılarıyla 8 Haziran 2014 Pazar günü Servet Tazegül Kapalı Spor Salonunda düzenlenen satranç turnuvasında ödül kazanan öğrencilerimizi kutluyor, başarılarının devamını diliyoruz.ÖDÜL KAZANAN ÖĞRENCİLERİMİZ7 Yaş 3. lük Furkan Aslan9 Yaş 2. lik Mehmet Eren Yüzükçü1.SINIFLARAltar GüvenoğluHatice Naz SolakKuzey ÇakıcıOğuz Kağan ÖzbayrakAli Emre Yüzükçü2.SINIFLARYağmur KaraM. Deniz TekinsoyHasan Yozgatİlker ÖzelTuğra BilginEfe Ahmetler3.SINIFLARArda GüçbeyUtku YazıcıAhmet ŞifanTutku TuraArda Canİdris İnanoğlu",
    "gallery": [
      "/files/images/t_New_8362542987.jpg",
      "/files/images/t_New_255548358.jpg"
    ],
    "video": ""
  },
  {
    "id": "7ve-8siniflar-kamp-etkinligimiz",
    "title": "7.ve 8.SINIFLAR KAMP ETKİNLİĞİMİZ",
    "image": "/files/images/t_13._4357263446.jpg",
    "description": "7.ve 8.SINIFLAR KAMP ETKİNLİĞİMİZ7. ve 8. sınıflarla yaptığımız gençlik kampında öğretmenlerimiz ve öğrencilerimiz birlikte olmanın verdiği mutluluğun, dayanışmanın, paylaşımın yaşandığı çok güzel bir akşam geçirdileri",
    "gallery": [
      "/files/images/t_13._4357263446.jpg",
      "/files/images/t_14._2747003436.jpg",
      "/files/images/t_15._7340967059.jpg",
      "/files/images/t_16._1825219989.jpg",
      "/files/images/t_17._7901422381.jpg",
      "/files/images/t_18._7924157977.jpg",
      "/files/images/t_20._2278253436.jpg",
      "/files/images/t_21._5281488299.jpg",
      "/files/images/t_22._3640100360.jpg",
      "/files/images/t_23._2786981464.jpg",
      "/files/images/t_24._590478778.jpg",
      "/files/images/t_25._70764423.jpg",
      "/files/images/t_26._9965478777.jpg",
      "/files/images/t_30._7929803729.jpg",
      "/files/images/t_31._4116174579.jpg",
      "/files/images/t_32._1108514667.jpg",
      "/files/images/t_33._6840631366.jpg",
      "/files/images/t_34._4573327899.jpg",
      "/files/images/t_35._2710229755.jpg",
      "/files/images/t_36._6605646014.jpg",
      "/files/images/t_37._4986841083.jpg",
      "/files/images/t_38._1429254413.jpg",
      "/files/images/t_39._6451532245.jpg",
      "/files/images/t_40._852929950.jpg",
      "/files/images/t_41._2798272968.jpg"
    ],
    "video": ""
  },
  {
    "id": "7siniflar-istanbul-gezisi",
    "title": "7.SINIFLAR İSTANBUL GEZİSİ",
    "image": "/files/images/t_2.j_6246911883.jpg",
    "description": "7.SINIFLAR İSTANBUL GEZİSİ7. Sınıflarımızın İstanbul Gezisi'nden Kareler....",
    "gallery": [
      "/files/images/t_2.j_6246911883.jpg",
      "/files/images/t_3.j_1691552997.jpg",
      "/files/images/t_4.j_3310663104.jpg",
      "/files/images/t_5.j_4750787616.jpg",
      "/files/images/t_6.j_5879632831.jpg",
      "/files/images/t_7.j_8340722918.jpg",
      "/files/images/t_8.j_5124017596.jpg",
      "/files/images/t_DSC_1980859638.JPG",
      "/files/images/t_DSC_4568445087.JPG",
      "/files/images/t_DSC_8000604510.JPG",
      "/files/images/t_DSC_9190484881.JPG",
      "/files/images/t_DSC_9699975848.JPG",
      "/files/images/t_DSC_7682306170.JPG",
      "/files/images/t_DSC_5334741473.JPG",
      "/files/images/t_DSC_5035211444.JPG",
      "/files/images/t_DSC_5237085223.JPG",
      "/files/images/t_18._8716089129.jpg",
      "/files/images/t_19._6448022723.jpg",
      "/files/images/t_19._7781183123.jpg",
      "/files/images/t_20._9524957537.jpg",
      "/files/images/t_23._1824914813.jpg",
      "/files/images/t_24._3388635516.jpg",
      "/files/images/t_25._4968835711.jpg",
      "/files/images/t_26._5889856219.jpg",
      "/files/images/t_27._9756891131.jpg",
      "/files/images/t_28._9450342059.jpg",
      "/files/images/t_29._2475854755.jpg",
      "/files/images/t_30._5614435077.jpg",
      "/files/images/t_31._3823053241.jpg",
      "/files/images/t_33._1894800067.jpg",
      "/files/images/t_34._6183435321.jpg",
      "/files/images/t_35._802423358.jpg",
      "/files/images/t_36._5005609393.jpg",
      "/files/images/t_37._5310937762.jpg",
      "/files/images/t_38._4137536883.jpg",
      "/files/images/t_39._794946552.jpg",
      "/files/images/t_40._2842370868.jpg",
      "/files/images/t_41._6290094256.jpg",
      "/files/images/t_42._2036859393.jpg",
      "/files/images/t_42._9334527850.jpg",
      "/files/images/t_43._8338128924.jpg",
      "/files/images/t_44._3489496112.jpg",
      "/files/images/t_45._2039758563.jpg",
      "/files/images/t_48._3210565448.jpg",
      "/files/images/t_50._4997064471.jpg",
      "/files/images/t_51._7209131121.jpg",
      "/files/images/t_52._279962421.jpg",
      "/files/images/t_53._6651574969.jpg",
      "/files/images/t_54._5685235858.jpg",
      "/files/images/t_55._3859369159.jpg",
      "/files/images/t_56._5167199969.jpg",
      "/files/images/t_57._7515069842.jpg",
      "/files/images/t_58._8932153582.jpg",
      "/files/images/t_59._790368915.jpg",
      "/files/images/t_60._904504657.jpg",
      "/files/images/t_62._3413507342.jpg",
      "/files/images/t_64._3586236835.jpg",
      "/files/images/t_65._2248498798.jpg",
      "/files/images/t_66._7385217547.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-sergisi",
    "title": "RESİM SERGİSİ",
    "image": "/files/images/t_1.j_4171869159.jpg",
    "description": "RESİM SERGİSİ23 Nisan Ulusal Egemenlik ve Çocuk Bayramıetkinlikleri içerisinde tüm okul öğrencilerimizin katıldığı resim sergimiz zemin katımızda açıldı. Büyük bir görsel şölen yaratan tüm okul öğrencilerimizi kutluyoruz.",
    "gallery": [
      "/files/images/t_1.j_4171869159.jpg",
      "/files/images/t_2.j_1642114520.jpg",
      "/files/images/t_3.j_2954675555.jpg",
      "/files/images/t_4.j_2104761005.jpg",
      "/files/images/t_5.j_2317010761.jpg",
      "/files/images/t_6.j_8302575946.jpg",
      "/files/images/t_7.j_9634210467.jpg",
      "/files/images/t_8.j_6572687030.jpg",
      "/files/images/t_9.j_6774713397.jpg",
      "/files/images/t_10._7586023211.jpg",
      "/files/images/t_11._2513696552.jpg",
      "/files/images/t_12._8025323748.jpg",
      "/files/images/t_13._2155572772.jpg",
      "/files/images/t_14._9649927020.jpg",
      "/files/images/t_15._2792779803.jpg",
      "/files/images/t_16._1310998798.jpg",
      "/files/images/t_17._4017297626.jpg",
      "/files/images/t_19._4497186542.jpg",
      "/files/images/t_20._2765161395.jpg",
      "/files/images/t_20._2845270038.jpg",
      "/files/images/t_20._7313348651.jpg",
      "/files/images/t_21._3303186298.jpg",
      "/files/images/t_22._3302575946.jpg",
      "/files/images/t_26._5347558856.jpg",
      "/files/images/t_27._9201928973.jpg",
      "/files/images/t_30._7700464129.jpg",
      "/files/images/t_32._3346063495.jpg",
      "/files/images/t_33._5064050555.jpg",
      "/files/images/t_35._7802240252.jpg",
      "/files/images/t_37._34448505.jpg",
      "/files/images/t_74._6961633563.jpg",
      "/files/images/t_77._7025110125.jpg",
      "/files/images/t_87._7442132830.jpg",
      "/files/images/t_DSC_9727136492.jpg",
      "/files/images/t_36._4714929462.jpg",
      "/files/images/t_66._879169.jpg"
    ],
    "video": ""
  },
  {
    "id": "satranc-turnuvasi",
    "title": "SATRANÇ TURNUVASI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "SATRANÇ TURNUVASIMersin Vergi Dairesi tarafından organize edilen \"Vergi Haftası Satranç Turnuvası\"nda 2-A sınıfı öğrencimiz Aydın Altar Güvenoğlu Mersin 3.sü oldu. Öğrencimizi kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_IMG_9331170916.jpg",
      "/files/images/t_IMG_9082452654.jpg"
    ],
    "video": ""
  },
  {
    "id": "tenis-turnuvasi",
    "title": "TENİS TURNUVASI",
    "image": "/files/images/t_1.j_6223871112.jpg",
    "description": "TENİS TURNUVASITürkiye Tenis Federasyonu’nun Mersin Tenis-Yelken ve Yüzme KulübündeDüzenlemiş Olduğu 8-9-10 Yaş Hafta SonuTenis TurnuvasındaÖdül Alan Öğrencilerimizi Kutlar, Başarılarının Devamını Dileriz.",
    "gallery": [
      "/files/images/l11102017102417108.JPG",
      "/files/images/l11102017102517154.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-yarismasi",
    "title": "RESİM YARIŞMASI",
    "image": "/files/images/t_1.j_5662500262.jpg",
    "description": "RESİM YARIŞMASIMonami'nin Türkiye geneli yapılan '' Çocuk ve Çevre'' konulu resim yarışmasında dereceye giren Ravel Deniz Saygı' ya ödül töreni yapıldı. Ödül töreninde madalyasını ve bisikletini alan öğrencimiz aynı zamanda küçüklerine örnek oldu. Öğrencimiz Ravel Deniz Saygı 'yı kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_1.j_5662500262.jpg",
      "/files/images/t_2.j_4845392108.jpg",
      "/files/images/t_3.j_3531762958.jpg",
      "/files/images/t_4.j_7483789325.jpg"
    ],
    "video": ""
  },
  {
    "id": "yuzme-sporlari",
    "title": "YÜZME SPORLARI",
    "image": "/files/images/t_1.j_935937763.jpg",
    "description": "YÜZME SPORLARI29 Mart 2014 tarihinde Türkiye Yüzme Federasyonu ve Mersin Yüzme İl Temsilciliği tarafından düzenlenen “Kardeş Şehir İller Müsabakaları” İl Karması Seçmelerinde 5. olarak bizleri gururlandıran öğrencimiz ŞİRA NUR EROĞLU’nu kutluyor ve başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_1.j_935937763.jpg",
      "/files/images/t_2.j_8254815936.jpg"
    ],
    "video": ""
  },
  {
    "id": "1siniflarimiz-devlet-opera-balesi`nde",
    "title": "1.SINIFLARIMIZ DEVLET OPERA BALESİ`NDE",
    "image": "/files/images/t_1.j_5691644549.jpg",
    "description": "1.SINIFLARIMIZ DEVLET OPERA BALESİ`NDE1.Sınıflar olarak Mersin Devlet Opera ve Balesine ‘’Opera Zamanı ‘’ adlı müzikli çocuk oyununu izlemeye gittik.Operanın çok eğlenceli  ve keyifli bir sahne sanatı olduğunu öğrendik.Bakalım  sırada hangi çocuk oyunu var? Merakla bekliyoruz.",
    "gallery": [
      "/files/images/t_1.j_5691644549.jpg",
      "/files/images/t_2.j_3478204608.jpg",
      "/files/images/t_4.j_956842304.jpg",
      "/files/images/t_5.j_172235370.jpg",
      "/files/images/t_8.j_1398126483.jpg"
    ],
    "video": ""
  },
  {
    "id": "costume-party",
    "title": "COSTUME PARTY",
    "image": "/files/images/t_kos_2693445087.jpg",
    "description": "COSTUME PARTYSayın Veli,11 Nisan Cuma günü, 8. ve 9. derslerde okul bahçesinde tüm öğrencilerimizin katılacağı ‘Kostüm Partisi’ yapılacaktır. Öğrencilerimizin kostümlerini yanlarında getirmelerini rica ederiz.İNGİLİZCE BÖLÜMÜ",
    "gallery": [
      "/files/images/t_kos_2693445087.jpg"
    ],
    "video": ""
  },
  {
    "id": "veli-bilgi-sistemi-",
    "title": "VELİ BİLGİ SİSTEMİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "VELİ BİLGİ SİSTEMİK12.NET VELİ BİLGİLENDİRME SİSTEMİNE GİRİŞ",
    "gallery": [],
    "video": ""
  },
  {
    "id": "tenis-turnuvasi",
    "title": "tenis turnuvası",
    "image": "/files/images/t_1.j_4715082049.jpg",
    "description": "tenis turnuvasıMersin Tenis Yelken ve Yüzme kulübünün düzenlemiş olduğu TFF 9 Yaş Tenis Turnuvasında Bayanlar 1. Grup Birincisi olan 3. Sınıf öğrencimiz Müge Cıllı’ya  ve Adana Atlı Spor Kulübünün 12 Yaş Tenis Turnuvasında Bayanlar Grup Birincisi olan 6. Sınıf öğrencimiz Nihan Öner’e madalyalarını sabah törenimizde verdik. Öğrencilerimizi kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_1.j_4715082049.jpg",
      "/files/images/t_1.j_7933771014.jpg",
      "/files/images/t_a.j_5693475604.jpg"
    ],
    "video": ""
  },
  {
    "id": "sinav-duyurusu",
    "title": "SINAV DUYURUSU",
    "image": "/images2/img2_files/logo.jpg",
    "description": "SINAV DUYURUSUDeğerli velilerimiz! 17 ocak  2014 cuma günü 5. -6.-7. ve 8. sınıf öğrencilerimize deneme sınavı uygulanacaktır.Bilgilerinize.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "yazili-tarihleri",
    "title": "YAZILI TARİHLERİ",
    "image": "/files/images/t_mah_3689691425.jpg",
    "description": "YAZILI TARİHLERİ2. Kademe 3. Yazılı tarihleri aşağıdaki ektedir.",
    "gallery": [
      "/files/images/t_mah_3689691425.jpg"
    ],
    "video": ""
  },
  {
    "id": "okulda-bir-gunumuz",
    "title": "OKULDA BİR GÜNÜMÜZ",
    "image": "/files/images/t_1.j_873224140.jpg",
    "description": "OKULDA BİR GÜNÜMÜZ7 Aralık Cumartesi günü 1.2. ve 3. sınıf öğrenci ve velilerine yönelik düzenlenen \"OKULDA BİR GÜNÜMÜZ\" etkinliği velilerimizin yoğun katılımıyla gerçekleşmiştir. Katılan tüm veli ve öğrencilerimize teşekkür ediyoruz.",
    "gallery": [
      "/files/images/t_1.j_873224140.jpg",
      "/files/images/t_2.j_3872339130.jpg",
      "/files/images/t_4.j_5357171893.jpg",
      "/files/images/t_5.j_7173578143.jpg",
      "/files/images/t_6.j_2209283710.jpg",
      "/files/images/t_7.j_7494012713.jpg",
      "/files/images/t_8.j_2414514423.jpg",
      "/files/images/t_9.j_7345697284.jpg",
      "/files/images/t_10._4758874774.jpg",
      "/files/images/t_11._7780572772.jpg",
      "/files/images/t_12._8278314471.jpg",
      "/files/images/t_13._7100946307.jpg",
      "/files/images/t_14._9883996844.jpg",
      "/files/images/t_15._3587915301.jpg",
      "/files/images/t_16._1926690936.jpg",
      "/files/images/t_17._657464862.jpg",
      "/files/images/t_18._1305658222.jpg",
      "/files/images/t_19._5527765155.jpg",
      "/files/images/t_20._1428949237.jpg",
      "/files/images/t_21._276910663.jpg",
      "/files/images/t_22._6025659442.jpg",
      "/files/images/t_23._8476068377.jpg",
      "/files/images/t_24._2556268573.jpg",
      "/files/images/t_25._7820093035.jpg",
      "/files/images/t_26._6500970721.jpg",
      "/files/images/t_27._8199121356.jpg",
      "/files/images/t_29._1292077899.jpg",
      "/files/images/t_30._5792505145.jpg",
      "/files/images/t_31._5727655291.jpg",
      "/files/images/t_32._8222009539.jpg",
      "/files/images/t_33._7855035662.jpg",
      "/files/images/t_34._9729267.jpg",
      "/files/images/t_35._6827051043.jpg",
      "/files/images/t_36._7672540545.jpg",
      "/files/images/t_37._5111047626.jpg",
      "/files/images/t_38._8196832537.jpg",
      "/files/images/t_39._7063409686.jpg",
      "/files/images/t_40._200769306.jpg"
    ],
    "video": ""
  },
  {
    "id": "deneme-sinavi-duyurusu",
    "title": "DENEME SINAVI DUYURUSU",
    "image": "/images2/img2_files/logo.jpg",
    "description": "DENEME SINAVI DUYURUSUVeli ve öğrencilerimizin dikkatine!10.12.2013 Salı günü sabah 5.6.7. ve 8. sınıflara deneme sınavı yapılacaktır. Bilgilerinize sunarız.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "antalya-kampi-son-gun-goruntuleri",
    "title": "ANTALYA KAMPI SON GÜN GÖRÜNTÜLERİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "ANTALYA KAMPI SON GÜN GÖRÜNTÜLERİSON GÜN VİDEOSUiledm_51f91a1f906b4",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/x1724f6"
  },
  {
    "id": "antalya-kamp-goruntuleri-5gun",
    "title": "ANTALYA KAMP GÖRÜNTÜLERİ 5.GÜN",
    "image": "/images2/img2_files/logo.jpg",
    "description": "ANTALYA KAMP GÖRÜNTÜLERİ 5.GÜNANTALYA KAMP 5iledm_51f91a1f906b4",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/x16z5xv"
  },
  {
    "id": "antalya-kamp-goruntuleri-4gun",
    "title": "ANTALYA KAMP GÖRÜNTÜLERİ 4.GÜN",
    "image": "/images2/img2_files/logo.jpg",
    "description": "ANTALYA KAMP GÖRÜNTÜLERİ 4.GÜN",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/x16xhpj"
  },
  {
    "id": "antalya-kamp-goruntuleri",
    "title": "ANTALYA KAMP GÖRÜNTÜLERİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "ANTALYA KAMP GÖRÜNTÜLERİ",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/x16w1fz"
  },
  {
    "id": "antalya-kampi-goruntuleri",
    "title": "ANTALYA KAMPI GÖRÜNTÜLERİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "ANTALYA KAMPI GÖRÜNTÜLERİSayın Velilerimiz, kamp görüntülerini linklerimiz üzerine tıklayarak izleyebilirsiniz.Önemli Not: Dosya uzunluğumuz küçültülerek web sitesine tekrardan atılmıştır. Dosyalarımızdowland linkine tıklanarak indirilebilmektedir.ANTALYA KAMPI GÖRÜNTÜLERİ - 1 . GÜNANTALYA KAMPI GÖRÜNTÜLERİ - 2. GÜNANTALYA KAMPI GÖRÜNTÜLERİ - 3. GÜNANTALYA KAMPI GÖRÜNTÜLERİ - 4. GÜNANTALYA KAMPI GÖRÜNTÜLERİ - 5. GÜN",
    "gallery": [],
    "video": ""
  },
  {
    "id": "2-siniflar-cumhuriyet-siiri",
    "title": "2. SINIFLAR CUMHURİYET ŞİİRİ",
    "image": "/files/images/t_1.j_925714374.jpg",
    "description": "2. SINIFLAR CUMHURİYET ŞİİRİ2-A  ve 2-B sınıfları ezberledikleri\"Cumhuriyet Bayramı\"adlı şiirlerini hafta içinde, tören alanında büyük bir çoşkuyla okudular.",
    "gallery": [
      "/files/images/t_1.j_925714374.jpg",
      "/files/images/t_2.j_6614801287.jpg",
      "/files/images/t_3.j_1376306415.jpg"
    ],
    "video": ""
  },
  {
    "id": "share--smile",
    "title": "SHARE  SMİLE",
    "image": "/files/images/t_1.j_1527063251.jpg",
    "description": "SHARE  SMİLEİngilizce paylaşım günlerimizin ilk etkinliği olan ‘’Share a Smile’’ gününde, öğrencilerimize kendi hazırladıkları rozet,maske, T-shirt, kolaj ve resim çalışmaları için teşekkür ederiz.",
    "gallery": [
      "/files/images/t_1.j_1527063251.jpg",
      "/files/images/t_2.j_1794397235.jpg",
      "/files/images/t_3.j_5887414813.jpg",
      "/files/images/t_4.j_1032525897.jpg",
      "/files/images/t_5.j_3512231708.jpg",
      "/files/images/t_6.j_93194843.jpg"
    ],
    "video": ""
  },
  {
    "id": "cambridge-sinav-sonuclari",
    "title": "CAMBRIDGE SINAV SONUÇLARI",
    "image": "/files/images/t_1.j_4003259540.jpg",
    "description": "CAMBRIDGE SINAV SONUÇLARIİngilizce bilgi düzeyini uluslararası boyutta belgelendirme amacına hizmet eden ve her yıl dünyanın her yerinden binlerce öğrencinin katıldığı Cambridge ESOL Sınavlarında gösterdiği üstün başarıdan dolayı öğrencilerimize teşekkür eder, başarılarının devamını dileriz.İNGİLİZCE BÖLÜMÜ",
    "gallery": [
      "/files/images/t_1.j_4003259540.jpg",
      "/files/images/t_2.j_5976220965.jpg",
      "/files/images/t_3.j_4628564715.jpg"
    ],
    "video": ""
  },
  {
    "id": "okulumuz-2013--2014-egitim--ogretim-yilina-basladi",
    "title": "OKULUMUZ 2013 - 2014 EĞİTİM - ÖĞRETİM YILINA BAŞLADI",
    "image": "/files/images/t_2.j_8106500506.jpg",
    "description": "OKULUMUZ 2013 - 2014 EĞİTİM - ÖĞRETİM YILINA BAŞLADIOkulumuz Atatürk'ün özlediği çağdaş uygarlık düzeyinin ancak bilgiyle mümkün olacağı düşüncesiyle 2013 - 2014 eğitim - öğretim yılına başlamaktadır.İlk ve Ortaöğretim; çağdaş eğitimin gereklerinin temellendirdiği, okuma - yazmanın ne kadar önemli olduğunun  aşılandığı en önemli temeldir.Gelişim Koleji ailesi olarak öğrencilerimizle birlikte Atatürk'ün hedef gösterdiği çağdaş uygarlık düzeyinin üstüne çıkma özlemini gerçekleştirmek amacıyla yola çıkıyoruz. Bu özlemi gerçekleştirmede en büyük önderin bilgi olduğunun bilincindeyiz. Bu bilinçle bilimi ve teknolojiyi kabul etmiş, edindiği bilgileri yaşamda kullanabilen, sorgulayan, düşünen öğrenciler  yetiştirme arzusu ve heyecanıyla doluyuz.Yeni bilgiler, yeni dostluklar, yeni paylaşımlar ve aydınlık yarınlara kavuşmamız dileğiyle öğrencilerimizin yeni eğitim - öğretim  yılını kutluyoruz.",
    "gallery": [
      "/files/images/t_2.j_8106500506.jpg"
    ],
    "video": ""
  },
  {
    "id": "2013--2014-egitim--ogretim-yili-zaman-cizelgesi",
    "title": "2013 - 2014 EĞİTİM - ÖĞRETİM YILI ZAMAN ÇİZELGESİ",
    "image": "/files/images/t_SAA_4989587665.jpg",
    "description": "2013 - 2014 EĞİTİM - ÖĞRETİM YILI ZAMAN ÇİZELGESİÖZEL GÜNEY GELİŞİM KOLEJİ 2013 - 2014 EĞİTİM - ÖĞRETİM YILI ZAMAN ÇİZELGESİ AÇIKLANDI.",
    "gallery": [
      "/files/images/t_SAA_4989587665.jpg"
    ],
    "video": ""
  },
  {
    "id": "sbs-gururlarimiz",
    "title": "SBS GURURLARIMIZ",
    "image": "/files/images/t_aaa_2128869891.jpg",
    "description": "SBS GURURLARIMIZ2012 - 2013 SBS SONUÇLARI AÇIKLANDI.Türkiye genelinde büyük başarılara imza atan öğrencilerimiz okulumuzu gururlandırdı. Üstün başarılar gösteren öğrencilerimizi kutlar, başarılarının gittikleri okullarda da devam etmesini temenni ederiz",
    "gallery": [
      "/files/images/t_aaa_2128869891.jpg"
    ],
    "video": ""
  },
  {
    "id": "",
    "title": "",
    "image": "/images2/img2_files/logo.jpg",
    "description": "",
    "gallery": [],
    "video": ""
  },
  {
    "id": "vip-anaokulu-yil-sonu-etkinliklerimizden-renkli-goruntuler",
    "title": "Vip Anaokulu Yıl Sonu Etkinliklerimizden Renkli Görüntüler",
    "image": "/files/images/t_DSC_4763757587.JPG",
    "description": "Vip Anaokulu Yıl Sonu Etkinliklerimizden Renkli Görüntüler",
    "gallery": [
      "/files/images/t_DSC_4763757587.JPG",
      "/files/images/t_DSC_7437860369.JPG",
      "/files/images/t_DSC_9658624529.JPG",
      "/files/images/t_DSC_5375787616.JPG",
      "/files/images/t_DSC_7082635760.JPG",
      "/files/images/t_DSC_9438440203.JPG",
      "/files/images/t_DSC_4147912860.JPG",
      "/files/images/t_DSC_4445764422.JPG",
      "/files/images/t_DSC_9927026629.JPG",
      "/files/images/t_DSC_7023279071.JPG",
      "/files/images/t_DSC_1400262714.JPG",
      "/files/images/t_DSC_9824640154.JPG",
      "/files/images/t_DSC_4351007342.JPG",
      "/files/images/t_DSC_5614892840.JPG",
      "/files/images/t_DSC_6844293475.JPG",
      "/files/images/t_DSC_2810479999.JPG",
      "/files/images/t_DSC_3203393817.JPG"
    ],
    "video": ""
  },
  {
    "id": "yilsonu-karne-haftasi-etkinliklerimiz",
    "title": "YILSONU KARNE HAFTASI ETKİNLİKLERİMİZ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "YILSONU KARNE HAFTASI ETKİNLİKLERİMİZEğlenceli bir hafta ile okulumuza veda ediyor, Yaz tatiline giriyoruz.*10.06.2013 Pazartesi Bowling keyfi,*11.06.2013 Salı Kahvaltı ve eğlenceli yarışmalar,*12.06.2013 Çarşamba sinema keyfi,*13.06.2013 Perşembe takım formaları ile maç keyfi,Oley oley formanı giy, maça hazır ol….Eylül’de buluşmak üzere………………………",
    "gallery": [],
    "video": ""
  },
  {
    "id": "ogrencimiz-ada-enon`un-uluslararasi-muzik-festivalindeki-basarisi",
    "title": "Öğrencimiz Ada Enön`ün Uluslararası Müzik Festivalindeki Başarısı",
    "image": "/files/images/t_Ads_4630395770.png",
    "description": "Öğrencimiz Ada Enön`ün Uluslararası Müzik Festivalindeki BaşarısıAntalyada yapılan 3. Uluslararası Müzik Festivalinde keman dalında yaşıtları arasında1. olan öğrencimiz Ada Enön ile gurur duyuyor başarılarının devamını diliyoruz.GELİŞİMileguneygelisimkoleji",
    "gallery": [
      "/files/images/t_Ads_4630395770.png"
    ],
    "video": "http://www.dailymotion.com/embed/video/xzp486"
  },
  {
    "id": "tanitim-2013",
    "title": "TANITIM 2013",
    "image": "/files/images/t_Ads_8378106951.jpg",
    "description": "TANITIM 2013",
    "gallery": [
      "/files/images/t_Ads_8378106951.jpg"
    ],
    "video": ""
  },
  {
    "id": "5-sinif-ogrencimiz-kutay-bartu-ozbek`in-digital-resim-sergisi-acildi",
    "title": "5. SINIF ÖĞRENCİMİZ KUTAY BARTU ÖZBEK`İN DİGİTAL RESİM SERGİSİ AÇILDI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "5. SINIF ÖĞRENCİMİZ KUTAY BARTU ÖZBEK`İN DİGİTAL RESİM SERGİSİ AÇILDI5. SINIF ÖĞRENCİMİZ KUTAY BARTU ÖZBEK`İN DİGİTAL RESİM SERGİSİ AÇILDI,YAPTIĞI BAŞARILI ÇALIŞMALARDAN ÖĞRENCİMİZE YÜREKTEN TEŞKKÜR EDERİZ.DİGİTAL SERGİ İÇİN TIKLAYINIZ...",
    "gallery": [],
    "video": ""
  },
  {
    "id": "ingilizce-show",
    "title": "İNGİLİZCE SHOW",
    "image": "/files/images/t_DSC_9315301776.JPG",
    "description": "İNGİLİZCE SHOW5 Nisan 2013 Cuma günü saat 19.00'da düzenlediğimiz ''İngilizce Gösterimiz'' tüm velilerimiz tarafından beğeniyle izlendi.Öğrencilerimiz yıl boyunca öğrendikleri konularda kısa kesitlerle rengarenk bir gösteri hazırladılar.Eme geçen tüm öğretmen ve öğrencilerimize teşekkür ederiz.English ShowThis year's English Show was held on April at 7.00 pm and was well received by all the parents in the audience.Our students,drawing inspiration from their lessons throughout the year,prepared wonderfully entertaining skits and other performancesWe thank all the teachers and students who worked so hard to make the show such as success .",
    "gallery": [
      "/files/images/t_DSC_9315301776.JPG",
      "/files/images/t_DSC_6411706805.JPG",
      "/files/images/t_DSC_9298517108.JPG",
      "/files/images/t_DSC_5390130877.JPG",
      "/files/images/t_DSC_3690149188.JPG",
      "/files/images/t_DSC_4320947528.JPG",
      "/files/images/t_DSC_224878192.JPG",
      "/files/images/t_DSC_4280359149.JPG",
      "/files/images/t_DSC_932275653.JPG",
      "/files/images/t_DSC_4400293231.JPG",
      "/files/images/t_DSC_5624353290.JPG",
      "/files/images/t_DSC_9246789813.JPG"
    ],
    "video": ""
  },
  {
    "id": "2013-sbs-basvurulari-baslamistir",
    "title": "2013 SBS Başvuruları Başlamıştır...",
    "image": "/images2/img2_files/logo.jpg",
    "description": "2013 SBS Başvuruları Başlamıştır...Sayın veli:2013 SBS başvuruları başlamıştır. Başvuru ücreti olan 10 liranın en geç 22 Mart Cuma gününe kadar Milli Eğitim Bakanlığı’nın Döner Sermaye İşletmesi’nin Ziraat Bankası Başkent/Ankara, Vakıflar Bankası Merkez/Ankara, Halk Bankası Küçükesat/Ankara şubelerinden herhangi birine öğrencinin T.C. kimlik numarasına göre yatırılması gerekmektedir. Bilginize.NOT: Banka dekontu üzerinde öğrencinin adı-soyadı, T.C. kimlik numarası ve gireceği sınavın adı mutlaka bulunmalıdır.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "09-mart-2013-cumartesi-kulup-ve-etut-duyurusu",
    "title": "09 Mart 2013 Cumartesi Kulüp ve Etüt Duyurusu...",
    "image": "/images2/img2_files/logo.jpg",
    "description": "09 Mart 2013 Cumartesi Kulüp ve Etüt Duyurusu...Sayın Velimiz 09 Mart Cumartesi günü Mersin genelinde sular kesik olduğundan Kulüp ve Etüt çalışmaları yapılmayacaktır.Bilgilerinize.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "4siniflar-yazili-sinav-tarihleri",
    "title": "4.SINIFLAR YAZILI SINAV TARİHLERİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "4.SINIFLAR YAZILI SINAV TARİHLERİ1.YAZILI                 2.YAZILI                             3.YAZILITÜRKÇE7 MART                 12 NİSAN24 MAYISMATEMATİK15 MART               19 NİSAN17 MAYISFEN VE TEKNOLOJİ3 NİSAN                  3 MAYISSOSYAL BİLGİLER10 NİSAN               15 MAYISDİN KÜL.ve AHLAK BİLGİSİ15 NİSAN                8 MAYISTRAFİK ve İLK YARDIM17 NİSAN               10 MAYIS",
    "gallery": [],
    "video": ""
  },
  {
    "id": "kostum-partisi",
    "title": "Kostüm Partisi",
    "image": "/files/images/t_IMG_5638238788.JPG",
    "description": "Kostüm Partisi28Aralık2012 Cuma günü İngilizce Bölümü olarak, okulumuzda kostüm partisi düzenledik. Birbirinden renkli kostümleriyle göz kamaştıran öğrencilerimiz, sevdikleri şarkılar ve oyunlar eşliğinde eğlenceli vakit geçirdiler.(Daha fazla fotoğraflar için tıklatın)",
    "gallery": [
      "/files/images/t_IMG_5638238788.JPG",
      "/files/images/t_IMG_9378625750.JPG"
    ],
    "video": ""
  },
  {
    "id": "10-kasim-anma-toreni",
    "title": "10 Kasım Anma Töreni",
    "image": "/images2/img2_files/logo.jpg",
    "description": "10 Kasım Anma TöreniAtam! Ağlamayın yas tutmayın dedin ya arkamdanSana en büyük ağıt azBize sensiz Türkiye en büyük yas10.11.2012 Atatürk'ü anma günü kapsamında hazırladığımız programda öğrencilerimiz, Atatürk'e duydukları saygı ve özlemi çeşitli etkinliklerle gösterme şansını buldular.Günün anlam ve önemini Evren Aldanmaz, “Çocukların dilinden Atatürk” videosu, Drama öğretmenimiz Sibel Kargın Bakmaz ve Sosyal Bilgiler öğretmeni DeryaKıdoğlu'nun hazırladığı “Atatürk'ten anılar” isimli canlandırmaları birer usta oyuncu gibi yansıttılar.Müzik öğretmenimiz Ezgi Erdoğan'ın yönettiği “Atatürk'ün sevdiği ezgiler” isimli koro etkinliğinde, öğretmen ve öğrencilerin birlikte sahne alması büyük ilgi çekti.Türkçe öğretmenimiz Şahin Yılmaz'ın yazıp yönettiği “Atatürk Oratoryosu” ile 10 Kasım Atatürk'ü anma programı sona erdi.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "teknoloji--ve-tasarim-dersi-proje-yarismasi-",
    "title": "TEKNOLOJİ  ve TASARIM DERSİ PROJE YARIŞMASI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "TEKNOLOJİ  ve TASARIM DERSİ PROJE YARIŞMASI6. 7. ve 8. sınıf öğrencilerimiz arasında düzenlenen “ Düzen Kuşağı” konulu proje yarışması tüm öğretmenlerimizin verdikleri oylarla değerlendirildi.Birincilik Ödülü Kimin mi ?9 Kasım Cuma günü  sabah töreninde açıklanacaktır.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "4siniflarin-yazili-tarihleri",
    "title": "4.SINIFLARIN YAZILI TARİHLERİ",
    "image": "/files/images/t_YAZ_6692010760.png",
    "description": "4.SINIFLARIN YAZILI TARİHLERİTABLOYU BÜYÜTMEK İÇİN TABLOYA TIKLAYIN...",
    "gallery": [
      "/files/images/t_YAZ_6692010760.png"
    ],
    "video": ""
  },
  {
    "id": "ogrenci-meclis-baskanini-sectik",
    "title": "Öğrenci Meclis Başkanını Seçtik",
    "image": "/files/images/t_DSC_3364984393.JPG",
    "description": "Öğrenci Meclis Başkanını Seçtik11/10/2012 tarihinde öğrenci meclisi başkanı ve başkan yardımcısı seçimi okulumuz öğrencilerinin katılımıyla yapıldı.Adaylar sonuçları büyük bir heyecanla beklediler. Seçim sonuçlarımızı seçim kurulunda görev alan arkadaşlarımız açıkladı.Öğrencilerimize yeni görevlerinde başarılar diliyoruz.Seçim kurulu:Fem YÜKSEL – Nehir AYDANOĞLU Yağmur AMBAR- Ege ZORLUTUNAOkul Meclis Başkanı         Başkan YardımcısıOzan GÜNDİÇ                 Selin VETEM",
    "gallery": [
      "/files/images/t_DSC_3364984393.JPG",
      "/files/images/t_DSC_209619403.JPG",
      "/files/images/t_DSC_8409082293.JPG",
      "/files/images/t_DSC_9359704852.JPG",
      "/files/images/t_DSC_7023126483.JPG",
      "/files/images/t_DSC_3020898700.JPG",
      "/files/images/t_DSC_2574426532.JPG"
    ],
    "video": ""
  },
  {
    "id": "cambridge-sinavlari-aciklandi",
    "title": "Cambridge Sınavları Açıklandı.",
    "image": "/files/images/t_DSC_9358484149.JPG",
    "description": "Cambridge Sınavları Açıklandı.Öğrencilerimiz Cambridge Üniversite'sinin İngilizce dil yeterliliğini ölçmek amacıyla, dünyanın birçok ülkesinde standart olarak uyguladığı İngilizce dil sınavlarında büyük başarı gösterdiler. Gelişim Koleji’nin her alandaki başarısını, İngilizce alanında da dünyaya kanıtlayan öğrencilerimizi ve İngilizce öğretmenlerimizi tebrik ederiz.",
    "gallery": [
      "/files/images/t_DSC_9358484149.JPG",
      "/files/images/t_201_7134668231.jpg",
      "/files/images/t_DSC_6218683123.JPG",
      "/files/images/t_DSC_66644550.JPG"
    ],
    "video": ""
  },
  {
    "id": "20122013-gelisim-koleji-deneme-sinavlari-takvimi",
    "title": "2012-2013 GELİŞİM KOLEJİ DENEME SINAVLARI TAKVİMİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "2012-2013 GELİŞİM KOLEJİ DENEME SINAVLARI TAKVİMİ2012 – 2013 GELİŞİM KOLEJİ DENEME SINAVLARI TAKVİMİ8. SINIFLAREKİM AYI – Bir DenemeKASIM AYI – Bir DenemeARALIK AYI – Bir DenemeOCAK AYI – Bir DenemeŞUBAT AYI – Bir DenemeMART AYI – İki DenemeNİSAN AYI – İki DenemeMAYIS AYI – Üç DenemeHAZİRAN AYI – Dört Deneme7. SINIFLAREKİM AYI – Bir DenemeKASIM AYI – Bir DenemeARALIK AYI – Bir DenemeOCAK AYI – Bir DenemeŞUBAT AYI – Bir DenemeMART AYI – Bir DenemeNİSAN AYI – Bir DenemeMAYIS AYI – Bir Deneme6. SINIFLARKASIM AYI – Bir DenemeOCAK AYI – Bir DenemeMART AYI – Bir DenemeMAYIS AYI – Bir Deneme5. SINIFLAROCAK AYI – Bir DenemeMART AYI – Bir DenemeMAYIS AYI – Bir Deneme",
    "gallery": [],
    "video": ""
  },
  {
    "id": "2012--2013-5678-siniflar-yazili-tarihleri",
    "title": "2012 - 2013 5-6-7-8. SINIFLAR YAZILI TARİHLERİ",
    "image": "/files/images/t_SIN_6344415545.jpg",
    "description": "2012 - 2013 5-6-7-8. SINIFLAR YAZILI TARİHLERİTabloyu büyütmek için tabloya tıklayınız...",
    "gallery": [
      "/files/images/t_SIN_6344415545.jpg"
    ],
    "video": ""
  },
  {
    "id": "comenius-project",
    "title": "Comenius Project",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Comenius Projectwww.flowersproject.com",
    "gallery": [],
    "video": ""
  }
];